/*
 * etikettenkaufen.com: Konfigurator für Aufkleber, Etiketten auf Bogen und Rolle, Magnet- und Großformataufkleber.
 * Preise kommen aus den Varianten der verknüpften Produkte.
 * Version 1.11, 14.10.2026
 */
(function () {
  'use strict';

  var VAT = 1.19;
  var DIN = { A3: [297, 420], A4: [210, 297], A5: [148, 210], A6: [105, 148] };
  var SHAPE_LABEL = { frei: 'Freie Kontur', rechteck: 'Rechteckig', abgerundet: 'Abgerundet', rund: 'Rund', oval: 'Oval' };
  var PRESETS = {
    aufkleber: { box: [[30, 30], [50, 50], [75, 75], [100, 100], [100, 50], [210, 297], [297, 420]], round: [30, 50, 75, 100] },
    bogen: { box: [[63.5, 38.1], [70, 37], [99.1, 38.1], [105, 74], [48.5, 25.4]], round: [30, 40, 60] },
    rolle: { box: [[50, 30], [60, 40], [70, 50], [100, 50], [100, 70]], round: [30, 40, 50, 60] },
    magnet: { box: [[100, 50], [100, 100], [148, 105], [210, 148], [297, 210], [600, 300]], round: [100, 150, 200] },
    gross: { box: [[200, 200], [300, 300], [500, 500], [700, 500], [1000, 500], [1000, 1000], [1000, 2000], [1300, 2500]], round: [200, 300, 500, 1000] }
  };
  /* Bezeichnungen je Produktfamilie (Aufkleber, Rolle, Magnet und Großformat nutzen dieselbe Preisrechnung);
     im Großformat kommt die Bezeichnung aus dem Abschnitt, z. B. Fensteraufkleber */
  var NOUN = { aufkleber: 'Aufkleber', rolle: 'Etiketten', magnet: 'Magnete' };
  var ITEM = { aufkleber: 'Aufkleber', bogen: 'Etiketten', rolle: 'Etiketten auf Rolle', magnet: 'Magnetaufkleber' };
  /* Wickelrichtung nach der üblichen Zählung. rot: Drehung des Etiketts auf der Bahn, wenn sie nach rechts abrollt */
  var WIND = {
    1: { side: 'außen', lead: 'Kopf voraus', rot: 90 },
    2: { side: 'außen', lead: 'Fuß voraus', rot: 270 },
    3: { side: 'außen', lead: 'rechts voraus', rot: 0 },
    4: { side: 'außen', lead: 'links voraus', rot: 180 },
    5: { side: 'innen', lead: 'Kopf voraus', rot: 90 },
    6: { side: 'innen', lead: 'Fuß voraus', rot: 270 },
    7: { side: 'innen', lead: 'rechts voraus', rot: 0 },
    8: { side: 'innen', lead: 'links voraus', rot: 180 }
  };
  var ROLL_GAP = 3; /* Abstand der Etiketten auf der Rolle, mm */
  var LABEL_FILL = { white_gloss: '#FFFFFF', white_matt: '#FAFAF7', paper: '#F8F4EA', paper_gloss: '#FBF8F0', transparent: 'rgba(255, 255, 255, .5)', silver: '#D8DDE1' };
  var FILLS = ['#FFF4D6', '#E2EFE8', '#F3E3EE', '#E1E8F5', '#FBE3DA', '#EDEBDD'];
  var FILE_OK = /\.(pdf|ai|eps|svg|png|jpe?g|tiff?)$/i;
  var IMG_OK = /\.(svg|png|jpe?g)$/i;
  var GAP = 2; /* Abstand der Schneidkontur zum Motiv bei freier Kontur, mm */
  /* Vergleichsgrößen für die Vorschau */
  var REFS = {
    coin: { w: 23.25, h: 23.25, label: '1-Euro-Münze, Ø 23,25 mm' },
    card: { w: 85.6, h: 53.98, label: 'Bankkarte, 85,6 × 54 mm' },
    a4: { w: 210, h: 297, label: 'DIN-A4-Blatt, 210 × 297 mm' },
    door: { w: 860, h: 1985, label: 'Zimmertür, 86 × 198,5 cm' }
  };
  var ICONS = {
    ok: '<svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true" focusable="false"><circle cx="10" cy="10" r="10" fill="currentColor"/><path d="m5.6 10.4 2.9 2.9 5.9-6.1" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    warn: '<svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true" focusable="false"><circle cx="10" cy="10" r="10" fill="currentColor"/><path d="M10 5.2v6" stroke="#fff" stroke-width="2.2" stroke-linecap="round"/><circle cx="10" cy="14.6" r="1.3" fill="#fff"/></svg>',
    info: '<svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true" focusable="false"><circle cx="10" cy="10" r="10" fill="currentColor"/><circle cx="10" cy="5.6" r="1.3" fill="#fff"/><path d="M10 8.8v6" stroke="#fff" stroke-width="2.2" stroke-linecap="round"/></svg>'
  };
  var STATUS_TXT = { ok: 'Gut: ', warn: 'Hinweis: ', bad: 'Achtung: ', info: 'Info: ' };

  var EUR2 = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 });
  var EUR3 = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 3, maximumFractionDigits: 3 });
  var DATE = new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: 'numeric', month: 'long' });

  function eur(cents) { return EUR2.format(cents / 100); }
  function eurUnit(cents) { return (cents < 10 ? EUR3 : EUR2).format(cents / 100); }
  function int(n) { return Math.round(n).toLocaleString('de-DE'); }
  /* Maß zum Lesen (über 999 mm mit Tausenderpunkt) und Maß für Eingabefelder (ohne Tausenderpunkt) */
  function mm(v) { return (Math.round(v * 10) / 10).toLocaleString('de-DE', { maximumFractionDigits: 1 }); }
  function mmIn(v) { return String(Math.round(v * 10) / 10).replace('.', ','); }
  function num(v) {
    var n = parseFloat(String(v == null ? '' : v).trim().replace(/\s+/g, '').replace(',', '.'));
    return isFinite(n) ? n : NaN;
  }
  function firstInt(s) {
    var m = String(s).replace(/\./g, '').match(/\d+/);
    return m ? parseInt(m[0], 10) : NaN;
  }
  /* Bogenformat aus dem Optionswert, z. B. "DIN A4 (210 × 297 mm)" oder "Großbogen (333 × 265 mm)" */
  function sheetInfo(s) {
    var v = String(s == null ? '' : s).trim();
    var info = { key: v.toLowerCase().replace(/\s+/g, ''), label: v.replace(/\s*\([^)]*\)\s*$/, '') || v, dims: null };
    var m = v.match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*(mm|cm)?/i);
    if (m) {
      var f = m[3] && m[3].toLowerCase() === 'cm' ? 10 : 1;
      info.dims = [num(m[1]) * f, num(m[2]) * f];
    } else {
      var d = v.match(/A\s?([3-6])(?!\d)/i);
      if (d) info.dims = DIN['A' + d[1]];
    }
    return info;
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function isoDay(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function uniqSorted(arr) {
    var out = [];
    arr.forEach(function (x) { if (out.indexOf(x) < 0) out.push(x); });
    return out.sort(function (a, b) { return a - b; });
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function plural(n, one, many) { return n === 1 ? one : many; }
  function joinList(a) { return a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' und ' + a[a.length - 1]; }

  /* Werktage ab heute (Freigabe bis cutoff Uhr), ohne Wochenenden und Feiertage */
  function deliveryDate(days, cutoff, holidays, now) {
    var d = now ? new Date(now.getTime()) : new Date();
    function ok(x) { var w = x.getDay(); return w !== 0 && w !== 6 && holidays.indexOf(isoDay(x)) < 0; }
    if (d.getHours() >= cutoff) d.setDate(d.getDate() + 1);
    while (!ok(d)) d.setDate(d.getDate() + 1);
    var k = 0;
    while (k < days) { d.setDate(d.getDate() + 1); if (ok(d)) k += 1; }
    return d;
  }

  /* Wie viele Etiketten passen auf den Bogen (auch quer gedreht) */
  function fitSheet(SW, SH, w, h, gx, gy, m) {
    function fit(a, b) {
      var cols = Math.max(0, Math.floor((SW - 2 * m + gx + 1e-9) / (a + gx)));
      var rows = Math.max(0, Math.floor((SH - 2 * m + gy + 1e-9) / (b + gy)));
      return { cols: cols, rows: rows, n: cols * rows, a: a, b: b, rotated: false };
    }
    var f1 = fit(w, h);
    var f2 = fit(h, w);
    if (f2.n > f1.n) { f2.rotated = true; return f2; }
    return f1;
  }

  /* ---------- Rolle ---------- */
  function windInfo(n) { return WIND[n] || WIND[1]; }
  function windText(n) { var x = windInfo(n); return (WIND[n] ? n : 1) + ' (' + x.side + ', ' + x.lead + ')'; }
  /* Option 3 der Varianten: "gerade" oder "Kontur" */
  function cutKey(v) {
    var t = String(v == null ? '' : v).trim().toLowerCase();
    if (!t) return null;
    return t.indexOf('kontur') !== -1 ? 'kontur' : 'gerade';
  }
  function fx(v) { return (Math.round(v * 100) / 100).toString(); }

  /* Umriss eines Etiketts, Mitte im Ursprung (für Rollenskizze und Zuschnitt des Motivs) */
  function labelShape(shape, w, h, cls, extra) {
    var a = ' class="' + cls + '"' + (extra || '');
    if (shape === 'rund' || shape === 'oval') return '<ellipse' + a + ' cx="0" cy="0" rx="' + fx(w / 2) + '" ry="' + fx(h / 2) + '"/>';
    var r = shape === 'abgerundet' ? 0.12 * Math.min(w, h) : (shape === 'frei' ? 0.3 * Math.min(w, h) : 0.04 * Math.min(w, h));
    return '<rect' + a + ' x="' + fx(-w / 2) + '" y="' + fx(-h / 2) + '" width="' + fx(w) + '" height="' + fx(h) + '" rx="' + fx(r) + '"/>';
  }

  /* Rollenskizze als SVG-Inhalt: Rolle links von oben gesehen, die Bahn rollt nach rechts ab.
     o: { W, H, n (Wickelrichtung), w, h (Etikett in mm), shape, swatch, img, id, small } */
  function rollSvg(o) {
    var small = !!o.small;
    var info = windInfo(o.n);
    var inner = info.side === 'innen';
    var upright = info.rot % 180 === 0;
    var along = upright ? o.w : o.h;
    var across = upright ? o.h : o.w;
    var gap = ROLL_GAP;
    var x0 = small ? 3 : 8;
    var rollW = small ? 15 : 42;
    var start = x0 + rollW;
    var tail = small ? 9 : 40;
    var avail = o.W - start - tail;
    var s = Math.min((o.H - (small ? 12 : 30)) / (across + 2 * gap), avail / (2.4 * along + 2 * gap));
    if (!small) s = Math.min(s, 3.6);
    var band = (across + 2 * gap) * s;
    var cy = o.H / 2;
    var by = cy - band / 2;
    var pitch = (along + gap) * s;
    var count = Math.max(1, Math.min(small ? 3 : 6, Math.floor((avail - gap * s) / pitch)));
    var end = start + gap * s + count * pitch;
    var fill = LABEL_FILL[o.swatch] || '#FFFFFF';
    var lw = o.w * s;
    var lh = o.h * s;
    var defs = '<linearGradient id="' + o.id + '-cyl" x1="0" x2="1" y1="0" y2="0">' +
      '<stop offset="0" stop-color="#C9C2AE"/><stop offset=".42" stop-color="#F3EFE4"/><stop offset="1" stop-color="#B7AF99"/></linearGradient>';
    if (o.img) defs += '<clipPath id="' + o.id + '-clip">' + labelShape(o.shape, lw, lh, 'ek-roll__clip') + '</clipPath>';
    var out = '<defs>' + defs + '</defs>';
    /* Bahn mit Abrisskante rechts */
    var zig = '';
    var steps = small ? 0 : Math.max(3, Math.round(band / 9));
    if (steps) {
      for (var z = 1; z <= steps; z++) zig += ' L' + fx(end + (z % 2 ? 5 : 0)) + ' ' + fx(by + band * z / steps);
    } else {
      zig = ' L' + fx(end) + ' ' + fx(by + band);
    }
    out += '<path class="ek-roll__web" d="M' + fx(start - 2) + ' ' + fx(by) + ' L' + fx(end) + ' ' + fx(by) + zig + ' L' + fx(start - 2) + ' ' + fx(by + band) + ' Z"/>';
    /* Etiketten: das rechte kommt zuerst von der Rolle */
    var g = Math.min(lw, lh) * 0.5 / 10;
    for (var i = 0; i < count; i++) {
      var cx = start + gap * s + along * s / 2 + i * pitch;
      out += '<g class="ek-roll__item' + (inner ? ' is-inner' : '') + '" transform="translate(' + fx(cx) + ' ' + fx(cy) + ') rotate(' + info.rot + ')">' +
        labelShape(o.shape, lw, lh, 'ek-roll__lbl', ' fill="' + fill + '"');
      if (o.img && !inner) {
        out += '<image href="' + esc(o.img) + '" x="' + fx(-lw * 0.44) + '" y="' + fx(-lh * 0.44) + '" width="' + fx(lw * 0.88) + '" height="' + fx(lh * 0.88) +
          '" preserveAspectRatio="xMidYMid meet" clip-path="url(#' + o.id + '-clip)"/>';
      } else {
        out += '<path class="ek-roll__glyph" d="M-3 4.2L0 -4.2L3 4.2M-1.8 1.4H1.8" transform="scale(' + fx(g) + ')"/>';
      }
      out += '</g>';
    }
    /* Rolle von oben: Zylinder in der Breite der Bahn */
    out += '<rect class="ek-roll__roll" x="' + x0 + '" y="' + fx(by - (small ? 1.5 : 4)) + '" width="' + rollW + '" height="' + fx(band + (small ? 3 : 8)) +
      '" rx="' + (small ? 2 : 5) + '" fill="url(#' + o.id + '-cyl)"/>';
    /* Pfeil: Abrollrichtung */
    var ax = end + (small ? 2 : 10);
    var aw = small ? 6 : 22;
    out += '<path class="ek-roll__arrow" d="M' + fx(ax) + ' ' + fx(cy) + ' H' + fx(ax + aw) + ' M' + fx(ax + aw - (small ? 2.5 : 6)) + ' ' + fx(cy - (small ? 2.5 : 6)) +
      ' L' + fx(ax + aw) + ' ' + fx(cy) + ' L' + fx(ax + aw - (small ? 2.5 : 6)) + ' ' + fx(cy + (small ? 2.5 : 6)) + '"/>';
    return out;
  }

  function Configurator(root) {
    this.root = root;
    this.cfg = JSON.parse(root.querySelector('script[data-ek-config]').textContent);
    this.mode = ['bogen', 'rolle', 'magnet', 'gross'].indexOf(this.cfg.mode) !== -1 ? this.cfg.mode : 'aufkleber';
    this.form = root.querySelector('[data-ek-form]');
    if (!this.form) return;
    this.el = {};
    var keys = ['price', 'tax', 'qtyline', 'lines', 'date', 'express', 'submit', 'error', 'summary', 'tiers', 'presets',
      'sticker', 'img', 'ph', 'dimw', 'dimh', 'pnote', 'pmeta', 'stage', 'sheet', 'fname', 'drop', 'later', 'wlabel',
      'sizeerr', 'fileerr', 'motiffield', 'mbar', 'mbarprice', 'live', 'sheethint', 'pre', 'tip', 'ref', 'reflabel',
      'cmp', 'share', 'shareok', 'ship', 'roll'];
    for (var i = 0; i < keys.length; i++) this.el[keys[i]] = root.querySelector('[data-ek-' + keys[i] + ']');
    this.hfields = Array.prototype.slice.call(root.querySelectorAll('[data-ek-hfield]'));
    this.inquiryLinks = Array.prototype.slice.call(root.querySelectorAll('[data-ek-inquiry]'));
    this.holidays = String(this.cfg.delivery.holidays || '').match(/\d{4}-\d{2}-\d{2}/g) || [];
    this.b2b = false;
    this.urls = [];
    this.analysis = [];
    this.anaToken = 0;
    this.preKey = '';
    this.cutKey = '';
    this.cmp = '';
    this.tierKey = '';
    this.presetKey = '';
    this.wantQty = this.cfg.defaults.qty;
    var self = this;
    this.materials = (this.cfg.materials || []).map(function (m) { return self.indexMaterial(m); });
    this.initGroups();
    if (this.mode === 'bogen') this.initSheets();
    if (this.mode === 'rolle') this.initWind();
    this.applyParams();
    this.bind();
    this.update();
    root.classList.add('is-ready');
  }

  /* Bezeichnung in Meldungen (Mehrzahl) und in der Preisübersicht; im Großformat aus dem Abschnitt */
  Configurator.prototype.noun = function () {
    return this.mode === 'gross' ? (this.cfg.itemName || 'Aufkleber') : (NOUN[this.mode] || 'Aufkleber');
  };
  Configurator.prototype.item = function () {
    return this.mode === 'gross' ? (this.cfg.itemName || 'Aufkleber') : (ITEM[this.mode] || 'Aufkleber');
  };

  Configurator.prototype.indexMaterial = function (m) {
    var bogen = this.mode === 'bogen';
    var rows = [];
    var cuts = [];
    (m.variants || []).forEach(function (v) {
      var si = bogen ? sheetInfo(v[1]) : null;
      var k1 = bogen ? (si.dims ? si.key : null) : firstInt(v[1]);
      var k2 = firstInt(v[2]);
      var cut = cutKey(v[5]);
      if (k1 && isFinite(k2)) {
        rows.push({ id: v[0], o1: v[1], o2: v[2], price: v[3], available: v[4] !== false, k1: k1, k2: k2, cut: cut });
        if (cut && cuts.indexOf(cut) === -1) cuts.push(cut);
      }
    });
    /* cuts: Schnitte aus Option 3 (leer = jede Form mit Konturschnitt); nur "gerade" heißt: nur rechteckig */
    return { key: m.key, handle: m.handle, label: m.label, swatch: m.swatch, rows: rows, cuts: cuts,
      rectOnly: cuts.length === 1 && cuts[0] === 'gerade',
      group: m.group || m.key, gname: m.gname || m.label, finish: m.finish && m.finish !== 'none' ? m.finish : '',
      maxMm: Number(m.maxMm) > 0 ? Number(m.maxMm) : 0 };
  };

  /* Materialgruppen in Block-Reihenfolge: eine Karte je Gruppe, darunter Laminat bzw. Oberfläche */
  Configurator.prototype.initGroups = function () {
    var groups = [];
    var byKey = {};
    this.materials.forEach(function (m) {
      var g = byKey[m.group];
      if (!g) {
        g = byKey[m.group] = { key: m.group, name: m.gname, mats: [] };
        groups.push(g);
      }
      g.mats.push(m);
    });
    this.groups = groups;
    this.groupByKey = byKey;
  };

  /* Material, das ein Klick auf die Gruppe wählt: von Folie zu Folie das gleiche Laminat, von Glanz- oder Mattlaminat
     zu Papier die passende Oberfläche, sonst das erste Material der Gruppe (bei Folien ohne Laminat) */
  Configurator.prototype.groupPick = function (g) {
    var cur = this.material();
    if (!g || !g.mats.length) return null;
    if (cur && cur.group === g.key) return cur;
    var f = cur ? cur.finish : '';
    var want = [];
    if (f === 'ohne' || f === 'glanz' || f === 'matt') want.push(f);
    if (f === 'glanz' || f === 'matt') want.push('o_' + f);
    for (var i = 0; i < want.length; i++) {
      for (var j = 0; j < g.mats.length; j++) if (g.mats[j].finish === want[i]) return g.mats[j];
    }
    return g.mats[0];
  };

  Configurator.prototype.pickGroup = function (key) {
    var m = this.groupPick(this.groupByKey[key]);
    if (!m) return;
    var inp = this.form.querySelector('input[name="material"][value="' + m.key + '"]');
    if (inp) {
      inp.disabled = false;
      inp.checked = true;
    }
  };

  /* Gruppe und Laminat-Auswahl an das gewählte Material anpassen */
  Configurator.prototype.syncFinish = function () {
    var mat = this.material();
    var g = mat ? this.groupByKey[mat.group] : null;
    if (!g) return;
    var self = this;
    Array.prototype.forEach.call(this.form.querySelectorAll('input[name="matgroup"]'), function (inp) {
      inp.checked = inp.value === g.key;
    });
    /* Musterfarbe jeder Karte wie das Material, das sie wählt (z. B. matt bei Mattlaminat) */
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-ek-group]'), function (card) {
      var pick = self.groupPick(self.groupByKey[card.getAttribute('data-ek-group')]);
      var sw = card.querySelector('.ek-swatch');
      if (sw && pick && pick.swatch) sw.className = 'ek-swatch ek-swatch--' + pick.swatch;
    });
    Array.prototype.forEach.call(this.form.querySelectorAll('[data-ek-fgroup]'), function (lab) {
      var on = lab.getAttribute('data-ek-fgroup') === g.key;
      lab.hidden = !on;
      var inp = lab.querySelector('input[name="material"]');
      if (inp) inp.disabled = !on;
    });
    var box = this.root.querySelector('[data-ek-finishbox]');
    if (!box) return;
    box.hidden = g.mats.length < 2;
    var surface = g.mats.some(function (m) { return /^o_/.test(m.finish); });
    var name = box.querySelector('[data-ek-finishname]');
    if (name) name.textContent = surface ? 'Oberfläche' : 'Laminat';
    var hint = box.querySelector('[data-ek-finishhint]');
    var hints = this.cfg.finishHints || {};
    if (hint) {
      hint.textContent = (surface ? hints.surface : hints.laminate) || '';
      hint.hidden = !hint.textContent;
    }
  };

  /* Skizzen der Wickelrichtungen, einmal beim Start */
  Configurator.prototype.initWind = function () {
    var uid = Math.random().toString(36).slice(2, 7);
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-ek-windpic]'), function (el) {
      var n = parseInt(el.getAttribute('data-ek-windpic'), 10);
      el.innerHTML = '<svg viewBox="0 0 96 50" focusable="false">' +
        rollSvg({ W: 96, H: 50, n: n, w: 15, h: 10, shape: 'rechteck', swatch: 'white_gloss', id: 'ekw' + uid + n, small: true }) + '</svg>';
    });
  };

  /* Werte aus dem Link übernehmen, z. B. vom Schnellrechner der Startseite.
     Unbekannte oder unpassende Werte werden ignoriert, die Startwerte aus dem Theme-Editor bleiben dann stehen. */
  Configurator.prototype.applyParams = function () {
    var q;
    try { q = new URLSearchParams(window.location.search); } catch (err) { return; }
    if (!q || !q.toString()) return;
    var self = this;
    function setRadio(name, test) {
      var radios = Array.prototype.slice.call(self.form.querySelectorAll('input[name="' + name + '"]'));
      var hit = radios.filter(test)[0];
      if (hit) hit.checked = true;
      return hit || null;
    }
    function okMm(v) { return isFinite(v) && v > 0 && v <= 5000; }

    var mat = String(q.get('material') || '').trim().toLowerCase();
    if (mat) {
      var byHandle = function (test) { return self.materials.filter(function (x) { return x.handle && test(String(x.handle).toLowerCase()); })[0]; };
      var m = byHandle(function (h) { return h === mat; })
        || byHandle(function (h) { return h.slice(-(mat.length + 1)) === '-' + mat; })
        || byHandle(function (h) { return h.indexOf(mat) !== -1; });
      if (m) setRadio('material', function (r) { return r.value === m.key; });
    }

    var shape = String(q.get('form') || '').trim().toLowerCase();
    if (shape && SHAPE_LABEL[shape]) setRadio('shape', function (r) { return r.value === shape; });

    var w = num(q.get('w'));
    var h = num(q.get('h'));
    if (okMm(w) && this.field('w')) this.field('w').value = mmIn(w);
    if (okMm(h) && this.field('h')) this.field('h').value = mmIn(h);
    else if (okMm(w) && this.field('h') && this.val('shape') === 'rund') this.field('h').value = mmIn(w);

    var qty = firstInt(q.get('menge') || q.get('anzahl') || '');
    if (isFinite(qty) && qty > 0) this.wantQty = qty;

    if (this.mode === 'rolle') {
      var wd = firstInt(q.get('wicklung') || '');
      if (WIND[wd]) setRadio('wind', function (r) { return parseInt(r.value, 10) === wd; });
    }

    var fmt = String(q.get('format') || '').trim().toLowerCase().replace(/\s+/g, '');
    if (fmt && this.mode === 'bogen') {
      var hit = setRadio('sheet', function (r) { return sheetInfo(r.value).key.indexOf(fmt) !== -1; });
      if (hit) this.wantSheet = hit.value;
    }

    if (this.mode === 'bogen') {
      var mot = firstInt(q.get('motive') || '');
      if (isFinite(mot) && mot >= 2 && this.field('motifs')) {
        setRadio('motifmode', function (r) { return r.value === 'multi'; });
        this.field('motifs').value = String(Math.min(mot, 50));
      }
      var gap = String(q.get('abstand') || '').trim();
      if (gap) {
        var gp = gap.split(/x|×/i);
        var gxv = num(gp[0]);
        var gyv = num(gp.length > 1 ? gp[1] : gp[0]);
        if (isFinite(gxv) && gxv >= 0 && gxv <= 50 && this.field('gx')) this.field('gx').value = mmIn(gxv);
        if (isFinite(gyv) && gyv >= 0 && gyv <= 50 && this.field('gy')) this.field('gy').value = mmIn(gyv);
      }
    }
  };

  /* Formate ohne Vorauswahl: erstes Format wählen; Symbole maßstäblich (0,09 px je mm) */
  Configurator.prototype.initSheets = function () {
    var radios = Array.prototype.slice.call(this.form.querySelectorAll('input[name="sheet"]'));
    if (radios.length && !radios.some(function (x) { return x.checked; })) radios[0].checked = true;
    var chk = radios.filter(function (x) { return x.checked; })[0];
    this.defSheet = chk ? chk.value : '';
    this.wantSheet = this.defSheet;
    radios.forEach(function (inp) {
      var d = sheetInfo(inp.value).dims;
      var icon = inp.parentNode.querySelector('.ek-sheeticon');
      if (!d || !icon) return;
      icon.style.width = Math.max(10, Math.round(d[0] * 0.09)) + 'px';
      icon.style.height = Math.max(10, Math.round(d[1] * 0.09)) + 'px';
    });
  };

  /* Formate je Material: nur vorhandene zeigen. Fehlt das gewählte Format, gilt das zuletzt gewählte, die Vorauswahl oder das erste. */
  Configurator.prototype.syncSheets = function () {
    var self = this;
    var mat = this.material();
    var have = {};
    (mat ? mat.rows : []).forEach(function (x) { have[x.k1] = true; });
    var radios = Array.prototype.slice.call(this.form.querySelectorAll('input[name="sheet"]'));
    var on = radios.filter(function (inp) { return have[sheetInfo(inp.value).key]; });
    if (!on.length) on = radios;
    var hidden = [];
    radios.forEach(function (inp) {
      var ok = on.indexOf(inp) !== -1;
      inp.disabled = !ok;
      var lab = inp.closest('label');
      if (lab) lab.hidden = !ok;
      if (!ok) hidden.push(inp);
    });
    function find(v) { return on.filter(function (inp) { return inp.value === v; })[0]; }
    var cur = on.filter(function (inp) { return inp.checked; })[0];
    var pick = find(this.wantSheet) || cur || find(this.defSheet) || on[0];
    if (pick && !pick.checked) pick.checked = true;
    if (this.el.sheethint) {
      var notes = hidden.map(function (inp) {
        var si = sheetInfo(inp.value);
        var mats = [];
        self.materials.forEach(function (m) {
          if (m.rows.some(function (x) { return x.k1 === si.key; }) && mats.indexOf(m.gname) === -1) mats.push(m.gname);
        });
        return mats.length ? si.label + ' gibt es nur mit ' + joinList(mats) + '.' : '';
      }).filter(Boolean);
      this.showMsg(this.el.sheethint, notes.join(' '));
    }
  };

  Configurator.prototype.field = function (name) { return this.form.elements[name]; };
  Configurator.prototype.val = function (name) {
    var f = this.field(name);
    return f ? f.value : '';
  };
  Configurator.prototype.material = function () {
    var key = this.val('material');
    for (var i = 0; i < this.materials.length; i++) if (this.materials[i].key === key) return this.materials[i];
    return this.materials[0];
  };

  Configurator.prototype.bind = function () {
    var self = this;
    var raf = null;
    function schedule() {
      if (raf) return;
      raf = window.requestAnimationFrame(function () { raf = null; self.update(); });
    }
    this.form.addEventListener('input', function (e) {
      self.touched = true;
      if (e.target.name === 'qty') self.wantQty = parseInt(e.target.value, 10);
      schedule();
    });
    this.form.addEventListener('change', function (e) {
      var t = e.target;
      self.touched = true;
      if (t.name === 'qty') self.wantQty = parseInt(t.value, 10);
      if (t.name === 'matgroup') self.pickGroup(t.value);
      if (t.name === 'matgroup' || t.name === 'material') self.onMaterial();
      if (t.name === 'shape') self.onShape();
      if (t.name === 'sheet') self.wantSheet = t.value;
      if (t.name === 'file') self.onFiles();
      schedule();
    });
    this.form.addEventListener('submit', function (e) { self.submit(e); });
    this.root.addEventListener('click', function (e) {
      if (e.target.closest('button')) self.touched = true;
      var preset = e.target.closest('[data-ek-preset]');
      if (preset) {
        e.preventDefault();
        var p = preset.getAttribute('data-ek-preset').split('x');
        self.field('w').value = p[0].replace('.', ',');
        if (self.field('h')) self.field('h').value = (p[1] || p[0]).replace('.', ',');
        self.update();
        return;
      }
      var b2b = e.target.closest('[data-ek-b2b]');
      if (b2b) {
        self.b2b = b2b.getAttribute('data-ek-b2b') === '1';
        Array.prototype.forEach.call(self.root.querySelectorAll('[data-ek-b2b]'), function (b) {
          b.setAttribute('aria-pressed', String((b.getAttribute('data-ek-b2b') === '1') === self.b2b));
        });
        self.tierKey = '';
        self.update();
        return;
      }
      var fit = e.target.closest('[data-ek-fit]');
      if (fit) {
        e.preventDefault();
        self.applySize(num(fit.getAttribute('data-w')), num(fit.getAttribute('data-h')));
        return;
      }
      var mset = e.target.closest('[data-ek-motifset]');
      if (mset) {
        e.preventDefault();
        var n = parseInt(mset.getAttribute('data-ek-motifset'), 10);
        var multi = self.form.querySelector('input[name="motifmode"][value="' + (n > 1 ? 'multi' : 'single') + '"]');
        if (multi) multi.checked = true;
        if (self.field('motifs') && n > 1) self.field('motifs').value = String(n);
        self.update();
        self.say('Anzahl Motive auf ' + n + ' gesetzt.' + self.priceSuffix());
        return;
      }
      var cmp = e.target.closest('[data-ek-cmp]');
      if (cmp) {
        self.cmp = cmp.getAttribute('data-ek-cmp') || '';
        Array.prototype.forEach.call(self.root.querySelectorAll('[data-ek-cmp]'), function (b) {
          b.setAttribute('aria-pressed', String((b.getAttribute('data-ek-cmp') || '') === self.cmp));
        });
        self.update();
        return;
      }
      var qbtn = e.target.closest('[data-ek-qty]');
      if (qbtn) {
        e.preventDefault();
        self.wantQty = parseInt(qbtn.getAttribute('data-ek-qty'), 10);
        self.update();
        var on = self.root.querySelector('input[name="qty"]:checked');
        if (on) on.focus();
        return;
      }
      if (e.target.closest('[data-ek-share]')) {
        e.preventDefault();
        self.share();
      }
    });
    var box = this.root.querySelector('.ek-pricebox');
    var mbar = this.el.mbar;
    if (box && mbar && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { mbar.classList.toggle('is-hidden', en.isIntersecting); });
      }, { threshold: 0.15 }).observe(box);
    }
    var drop = this.el.drop;
    if (drop) {
      ['dragenter', 'dragover'].forEach(function (ev) {
        drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); });
      });
      ['dragleave', 'drop'].forEach(function (ev) {
        drop.addEventListener(ev, function () { drop.classList.remove('is-over'); });
      });
      drop.addEventListener('drop', function (e) {
        e.preventDefault();
        var input = self.field('file');
        if (input && e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
          var list = e.dataTransfer.files;
          if (!input.multiple && list.length > 1) {
            try { var dt = new DataTransfer(); dt.items.add(list[0]); list = dt.files; } catch (err1) { return; }
          }
          try { input.files = list; } catch (err) { return; }
          self.onFiles();
          self.update();
        }
      });
    }
  };

  Configurator.prototype.onShape = function () {
    var round = this.val('shape') === 'rund';
    var h = this.field('h');
    if (h && !round && !h.value) h.value = this.val('w');
  };

  /* Großformat: Material nur mit geradem Schnitt (z. B. statisch haftende Folie) gewählt, dann Form rechteckig */
  Configurator.prototype.onMaterial = function () {
    var m = this.material();
    if (this.mode !== 'gross' || !m || !m.rectOnly) return;
    var shape = this.val('shape');
    var rect = this.form.querySelector('input[name="shape"][value="rechteck"]');
    if (!rect || !shape || shape === 'rechteck') return;
    if (shape === 'rund' && this.field('h')) this.field('h').value = this.val('w');
    rect.checked = true;
    this.onShape();
    /* Ansage nach der nächsten Berechnung, mit dem neuen Preis */
    this.pendingSay = m.label + ' gibt es nur rechteckig. Form auf Rechteckig gestellt.';
  };

  /* ---------- Dateien ---------- */
  Configurator.prototype.selectedFiles = function () {
    var input = this.field('file');
    return input && input.files ? Array.prototype.slice.call(input.files) : [];
  };

  Configurator.prototype.checkFiles = function (files) {
    var lim = this.cfg.limits;
    var max = (lim.maxFileMb || 20) * 1024 * 1024;
    if (this.mode === 'bogen' && files.length > (lim.maxFiles || 5)) {
      return 'Bitte höchstens ' + (lim.maxFiles || 5) + ' Dateien wählen. Mehr Motive gern als mehrseitiges PDF.';
    }
    for (var i = 0; i < files.length; i++) {
      if (!FILE_OK.test(files[i].name)) return '„' + files[i].name + '“ hat ein Format, das wir nicht annehmen. Bitte PDF, AI, EPS, SVG, PNG, JPG oder TIF.';
      if (files[i].size > max) return '„' + files[i].name + '“ ist größer als ' + (lim.maxFileMb || 20) + ' MB. Bitte verkleinern oder später per E-Mail senden.';
    }
    return '';
  };

  Configurator.prototype.onFiles = function () {
    var files = this.selectedFiles();
    this.urls.forEach(function (u) { try { URL.revokeObjectURL(u.url); } catch (e) { /* egal */ } });
    this.urls = [];
    var err = this.checkFiles(files);
    this.showMsg(this.el.fileerr, err);
    if (this.el.fname) {
      this.el.fname.textContent = files.length
        ? files.map(function (f) {
          var size = f.size < 1048576 ? Math.max(1, Math.round(f.size / 1024)) + ' KB' : (f.size / 1048576).toFixed(1).replace('.', ',') + ' MB';
          return f.name + ' (' + size + ')';
        }).join(', ')
        : 'Keine Datei ausgewählt';
      this.el.fname.classList.toggle('has-file', files.length > 0);
    }
    if (!err && window.URL && URL.createObjectURL) {
      var self = this;
      files.forEach(function (f) {
        if (IMG_OK.test(f.name)) self.urls.push({ url: URL.createObjectURL(f), name: f.name });
      });
    }
    if (files.length) {
      var up = this.form.querySelector('input[name="files"][value="upload"]');
      if (up) up.checked = true;
    }
    this.analyzeFiles(err ? [] : files);
  };

  /* Schnellcheck: jede Datei im Browser lesen (ek-druckcheck.js), danach neu zeichnen */
  Configurator.prototype.analyzeFiles = function (files) {
    var self = this;
    this.analysis.forEach(function (a) { if (a && a.url) { try { URL.revokeObjectURL(a.url); } catch (e) { /* egal */ } } });
    this.anaToken += 1;
    this.analysis = [];
    this.preKey = '';
    this.cutKey = '';
    var token = this.anaToken;
    var dc = window.EkDruckcheck;
    if (!dc || !files.length) return;
    files.forEach(function (f, i) {
      self.analysis[i] = { pending: true, name: f.name, ext: dc.extOf(f.name) };
      dc.analyze(f).then(function (info) {
        if (token !== self.anaToken) {
          if (info && info.url) { try { URL.revokeObjectURL(info.url); } catch (e) { /* egal */ } }
          return;
        }
        self.analysis[i] = info;
        self.preKey = '';
        self.cutKey = '';
        self.update();
        if (self.analysis.every(function (a) { return a && !a.pending; })) self.announceChecks();
      }, function () {
        if (token !== self.anaToken) return;
        self.analysis[i] = { name: f.name, ext: dc.extOf(f.name), kind: 'other', problem: 'read' };
        self.preKey = '';
        self.update();
      });
    });
  };

  /* ---------- Berechnung ---------- */
  Configurator.prototype.pickQty = function (tiers) {
    var want = this.wantQty;
    for (var i = 0; i < tiers.length; i++) if (tiers[i].k2 === want) return want;
    for (var j = 0; j < tiers.length; j++) if (tiers[j].k2 >= want) return tiers[j].k2;
    return tiers.length ? tiers[tiers.length - 1].k2 : NaN;
  };

  Configurator.prototype.addLayout = function (r) {
    var lay = this.field('layout');
    if (lay && lay.checked && this.cfg.layout) {
      r.addons.push({ key: 'layout', id: this.cfg.layout.id, qty: 1, price: this.cfg.layout.price, label: 'Layout-Service' });
    }
  };

  Configurator.prototype.finish = function (r) {
    if (r.variant) {
      /* Datencheck mit PDF-Vorschau gehört zu jeder Druckposition, deshalb steckt er in jedem angezeigten Preis */
      if (this.cfg.check) r.addons.unshift({ key: 'check', id: this.cfg.check.id, qty: 1, price: this.cfg.check.price, label: 'Datencheck und PDF-Vorschau' });
      r.extra = 0;
      r.addons.forEach(function (a) { r.extra += a.price; });
      r.total = r.variant.price + r.extra;
      r.ok = r.variant.available;
      if (!r.variant.available) r.reason = 'Diese Variante ist derzeit nicht verfügbar. Gern erstellen wir Ihnen ein Angebot.';
    }
    return r;
  };

  /* Aufkleber, Etiketten auf Rolle und Magnete: Preis über Flächenstufe und Menge, bei Rolle und Magnet zusätzlich nach Schnitt */
  Configurator.prototype.computeAufkleber = function () {
    var lim = this.cfg.limits;
    var roll = this.mode === 'rolle';
    var mag = this.mode === 'magnet';
    var gross = this.mode === 'gross';
    var noun = this.noun();
    var shape = this.val('shape') || (roll || mag ? 'rechteck' : 'frei');
    var round = shape === 'rund';
    var w = num(this.val('w'));
    var h = round ? w : num(this.val('h'));
    var mat = this.material();
    var r = { mode: this.mode, shape: shape, round: round, w: w, h: h, mat: mat, ok: false, reason: '', tiers: [], addons: [], total: 0 };
    if (roll) {
      r.wind = parseInt(this.val('wind'), 10);
      if (!WIND[r.wind]) r.wind = parseInt(this.cfg.wind, 10) || 1;
      r.cut = shape === 'rechteck' ? 'gerade' : 'kontur';
    }
    if (mag || gross) r.cut = shape === 'rechteck' ? 'gerade' : 'kontur';
    if (!mat || !mat.rows.length) { r.reason = 'Für diese Ausführung sind noch keine Preise hinterlegt.'; return r; }
    if (!isFinite(w) || !isFinite(h)) {
      r.reason = round ? 'Bitte geben Sie den Durchmesser in mm ein.' : 'Bitte geben Sie Breite und Höhe in mm ein.';
      r.sizeError = true;
      return r;
    }
    if (w < lim.min || h < lim.min || w > lim.max || h > lim.max) {
      r.reason = 'Bitte ein Maß zwischen ' + int(lim.min) + ' und ' + int(lim.max) + ' mm eingeben. Größere ' + noun + ' auf Anfrage.';
      r.sizeError = true;
      r.inquiry = w > lim.max || h > lim.max;
      return r;
    }
    /* Höchstmaß der kürzeren Seite, z. B. große Aufkleber bis 470 × 1.500 mm */
    if (lim.maxShort && Math.min(w, h) > lim.maxShort) {
      r.reason = round
        ? 'Runde ' + noun + ' gibt es bis Ø ' + int(lim.maxShort) + ' mm. Größere auf Anfrage.'
        : noun + ' gibt es bis ' + int(lim.maxShort) + ' × ' + int(lim.max) + ' mm: Eine Seite darf höchstens ' +
          int(lim.maxShort) + ' mm lang sein. Größere ' + noun + ' auf Anfrage.';
      r.sizeError = true;
      r.inquiry = true;
      return r;
    }
    /* Mindestmaß mit längerer Seite, z. B. Magnete ab 50 × 100 mm */
    if (lim.minLong && Math.max(w, h) < lim.minLong) {
      r.reason = round
        ? 'Runde ' + noun + ' gibt es ab Ø ' + lim.minLong + ' mm. Kleinere auf Anfrage.'
        : 'Mindestens ' + lim.min + ' × ' + lim.minLong + ' mm: Eine Seite muss mindestens ' + lim.minLong + ' mm lang sein. Kleinere ' + noun + ' auf Anfrage.';
      r.sizeError = true;
      r.inquiry = true;
      return r;
    }
    r.area = (w * h) / 100;
    /* Höchstmaß je Material, z. B. Papier bis 250 mm; die Karten der anderen Materialien zeigen weiter ihren Preis */
    if (mat.maxMm && Math.max(w, h) > mat.maxMm) {
      r.reason = mat.label + ' gibt es bis ' + int(mat.maxMm) + ' mm je Seite. Für größere ' + noun + ' wählen Sie bitte ein anderes Material.';
      r.matLimit = true;
      return r;
    }
    /* Großformat: Material nur mit geradem Schnitt (z. B. statisch haftende Folie) gibt es nur rechteckig;
       die Karten der anderen Materialien zeigen weiter ihren Preis */
    if (gross && mat.rectOnly && r.cut !== 'gerade') {
      r.reason = mat.label + ' gibt es nur rechteckig, gerade geschnitten. Für andere Formen wählen Sie bitte ein anderes Material.';
      r.matLimit = true;
      r.shapeLimit = true;
      return r;
    }
    var rows = mat.rows;
    if (r.cut && rows.some(function (x) { return x.cut; })) {
      rows = rows.filter(function (x) { return x.cut === r.cut; });
      if (!rows.length) { r.reason = 'Diese Form gibt es für das gewählte Material nicht. Gern erstellen wir Ihnen ein Angebot.'; r.inquiry = true; return r; }
    }
    var classes = uniqSorted(rows.map(function (x) { return x.k1; }));
    var cls;
    for (var i = 0; i < classes.length; i++) if (classes[i] + 1e-9 >= r.area) { cls = classes[i]; break; }
    if (cls === undefined) {
      r.reason = 'Für ' + noun + ' über ' + int(classes[classes.length - 1]) + ' cm² erstellen wir Ihnen gern ein Angebot.';
      r.inquiry = true;
      return r;
    }
    r.cls = cls;
    r.tiers = rows.filter(function (x) { return x.k1 === cls; }).sort(function (a, b) { return a.k2 - b.k2; });
    r.qty = this.pickQty(r.tiers);
    r.variant = r.tiers.filter(function (t) { return t.k2 === r.qty; })[0];
    r.units = r.qty;
    this.addLayout(r);
    return this.finish(r);
  };

  Configurator.prototype.computeBogen = function () {
    var lim = this.cfg.limits;
    var si = sheetInfo(this.val('sheet'));
    var sheet = si.key;
    var shape = this.val('shape') || 'rechteck';
    var round = shape === 'rund';
    var w = num(this.val('w'));
    var h = round ? w : num(this.val('h'));
    var gx = num(this.val('gx'));
    var gy = num(this.val('gy'));
    gx = isFinite(gx) && gx > 0 ? Math.min(gx, 50) : 0;
    gy = isFinite(gy) && gy > 0 ? Math.min(gy, 50) : 0;
    var mat = this.material();
    var dims = si.dims || DIN.A4;
    var r = { mode: 'bogen', sheet: sheet, sheetLabel: si.label || 'Bogen', shape: shape, round: round, w: w, h: h, gx: gx, gy: gy, mat: mat, dims: dims,
      ok: false, reason: '', tiers: [], addons: [], total: 0, motifs: 1 };
    if (!mat || !mat.rows.length) { r.reason = 'Für dieses Material sind noch keine Preise hinterlegt.'; return r; }
    if (!isFinite(w) || !isFinite(h)) {
      r.reason = round ? 'Bitte geben Sie den Durchmesser in mm ein.' : 'Bitte geben Sie Breite und Höhe in mm ein.';
      r.sizeError = true;
      return r;
    }
    if (w < lim.min || h < lim.min) {
      r.reason = 'Etiketten ab ' + lim.min + ' mm. Kleinere Maße auf Anfrage.';
      r.sizeError = true;
      return r;
    }
    var L = fitSheet(dims[0], dims[1], w, h, gx, gy, lim.margin);
    r.layout = L;
    r.per = L.n;
    if (!L.n) {
      r.reason = 'Das Etikett passt so nicht auf den Bogen. Bitte ein kleineres Maß oder einen größeren Bogen wählen.';
      r.sizeError = true;
      return r;
    }
    r.tiers = mat.rows.filter(function (x) { return x.k1 === sheet; }).sort(function (a, b) { return a.k2 - b.k2; });
    if (!r.tiers.length) { r.reason = 'Dieses Bogenformat gibt es für das gewählte Material nicht.'; return r; }
    r.qty = this.pickQty(r.tiers);
    r.variant = r.tiers.filter(function (t) { return t.k2 === r.qty; })[0];
    r.units = r.qty * r.per;
    if (this.val('motifmode') === 'multi') {
      var m = Math.round(num(this.val('motifs')));
      if (!isFinite(m) || m < 2) m = 2;
      r.motifs = Math.min(m, 50, r.units);
      r.motifsCapped = m > r.motifs;
    }
    if (r.motifs > 1 && this.cfg.motif) {
      var extra = r.motifs - 1;
      r.addons.push({ key: 'motif', id: this.cfg.motif.id, qty: extra, price: this.cfg.motif.price * extra,
        label: extra + ' ' + plural(extra, 'weiteres Motiv', 'weitere Motive') });
    }
    this.addLayout(r);
    return this.finish(r);
  };

  /* ---------- Darstellung ---------- */
  Configurator.prototype.shown = function (cents) { return this.b2b ? cents / VAT : cents; };

  Configurator.prototype.showMsg = function (el, text) {
    if (!el) return;
    text = text || '';
    if (el.textContent === text && el.hidden === !text) return;
    el.textContent = text;
    el.hidden = !text;
  };

  Configurator.prototype.update = function () {
    this.syncFinish();
    if (this.mode === 'bogen') this.syncSheets();
    var r = this.mode === 'bogen' ? this.computeBogen() : this.computeAufkleber();
    this.current = r;
    this.renderSizeUi(r);
    this.renderPresets(r);
    this.renderTiers(r);
    this.renderTip(r);
    this.renderMatPrices(r);
    if (this.mode === 'bogen') this.renderSheet(r); else this.renderSticker(r);
    if (this.mode === 'rolle') this.renderRoll(r);
    this.renderFilesUi();
    this.renderPreflight(r);
    this.renderPrice(r);
    this.syncChecked();
    this.syncUrl(r);
    if (this.pendingSay) {
      var msg = this.pendingSay;
      this.pendingSay = '';
      this.say(msg + this.priceSuffix());
    }
  };

  /* Kurze Ansage für Screenreader. Eine wartende Preisansage entfällt dann (sonst überschreibt sie diese Ansage). */
  Configurator.prototype.say = function (text) {
    var live = this.el.live;
    if (!live) return;
    window.clearTimeout(this.liveTimer);
    if (this.current) this.lastLive = this.priceText(this.current);
    live.textContent = '';
    window.setTimeout(function () { live.textContent = text; }, 60);
  };

  /* Preis für die Ansage; Fehler beim Maß sagt schon die Meldung mit role="alert" an */
  Configurator.prototype.priceText = function (r) {
    if (r.variant) return 'Preis ' + eur(this.shown(r.total)) + (this.b2b ? ' netto' : '');
    return r.sizeError ? '' : (r.reason || '');
  };
  Configurator.prototype.priceSuffix = function () {
    var r = this.current;
    return r && r.variant ? ' ' + this.priceText(r) + '.' : '';
  };

  /* Maß setzen (Knopf „Maß an Motiv anpassen“ im Schnellcheck) */
  Configurator.prototype.applySize = function (w, h) {
    if (!isFinite(w) || !isFinite(h)) return;
    if (this.field('w')) this.field('w').value = mmIn(w);
    if (this.field('h')) this.field('h').value = mmIn(h);
    this.update();
    var r = this.current;
    this.say('Maß angepasst: ' + (r && r.round ? 'Ø ' + mm(w) : mm(w) + ' × ' + mm(h)) + ' mm.' + this.priceSuffix());
    if (this.el.pre && !this.el.pre.hidden) this.el.pre.focus();
  };

  Configurator.prototype.syncChecked = function () {
    Array.prototype.forEach.call(this.form.querySelectorAll('input[type="radio"], input[type="checkbox"]'), function (inp) {
      var lab = inp.closest('label');
      if (lab) lab.classList.toggle('is-checked', inp.checked);
    });
  };

  Configurator.prototype.renderSizeUi = function (r) {
    var round = r.round;
    this.hfields.forEach(function (el) { el.hidden = round; });
    if (this.el.wlabel) this.el.wlabel.textContent = round ? 'Durchmesser' : 'Breite';
    this.showMsg(this.el.sizeerr, r.sizeError ? r.reason : '');
    var w = this.field('w');
    var h = this.field('h');
    if (w) w.setAttribute('aria-invalid', r.sizeError ? 'true' : 'false');
    if (h) h.setAttribute('aria-invalid', r.sizeError && !round ? 'true' : 'false');
    if (this.el.motiffield) this.el.motiffield.hidden = this.val('motifmode') !== 'multi';
  };

  Configurator.prototype.renderPresets = function (r) {
    var box = this.el.presets;
    if (!box) return;
    var set = PRESETS[this.mode];
    var lim = this.cfg.limits;
    var list = (r.round ? set.round.map(function (d) { return [d, d]; }) : set.box).filter(function (p) {
      var a = Math.max(p[0], p[1]);
      var b = Math.min(p[0], p[1]);
      return a <= lim.max && b >= lim.min && (!lim.maxShort || b <= lim.maxShort);
    });
    var key = (r.round ? 'r' : 'b') + '|' + r.w + '|' + r.h;
    if (key === this.presetKey) return;
    this.presetKey = key;
    var html = '<span class="ek-presets__label">Gängige Maße:</span>';
    list.forEach(function (p) {
      var on = Math.abs(p[0] - r.w) < 0.05 && Math.abs(p[1] - r.h) < 0.05;
      var label = r.round ? 'Ø ' + mm(p[0]) : mm(p[0]) + ' × ' + mm(p[1]);
      html += '<button type="button" class="ek-preset' + (on ? ' is-active' : '') + '" data-ek-preset="' + p[0] + 'x' + p[1] +
        '" aria-pressed="' + on + '">' + label + '</button>';
    });
    box.innerHTML = html;
  };

  Configurator.prototype.renderTiers = function (r) {
    var box = this.el.tiers;
    if (!box) return;
    var bogen = this.mode === 'bogen';
    var extra = r.extra || 0;
    var key = [r.mat ? r.mat.key : '', bogen ? r.sheet : r.cls, bogen ? r.per : '', r.cut || '', this.b2b, r.tiers.length, extra].join('|');
    if (!r.tiers.length) {
      this.tierKey = '';
      box.innerHTML = '<p class="ek-tiers__empty">' + esc(r.reason || 'Bitte Maß prüfen.') + '</p>';
      return;
    }
    var self = this;
    if (key !== this.tierKey) {
      this.tierKey = key;
      var name = 'qty';
      var head = bogen
        ? '<span>Bogen</span><span>Etiketten</span><span>je Bogen</span><span>Gesamt</span>'
        : '<span>Menge</span><span>je Stück</span><span>Gesamt</span>';
      var html = '<div class="ek-tiers__head' + (bogen ? ' ek-tiers--4' : '') + '" aria-hidden="true">' + head + '</div>';
      r.tiers.forEach(function (t) {
        var price = self.shown(t.price + extra);
        var cells;
        if (bogen) {
          cells = '<span class="ek-tier__q">' + int(t.k2) + ' Bogen</span>' +
            '<span class="ek-tier__n">' + int(t.k2 * r.per) + '<span class="ek-vh"> Etiketten</span></span>' +
            '<span class="ek-tier__per">' + eurUnit(price / t.k2) + '<span class="ek-vh"> je Bogen</span></span>';
        } else {
          cells = '<span class="ek-tier__q">' + int(t.k2) + ' Stück</span>' +
            '<span class="ek-tier__per">' + eurUnit(price / t.k2) + '<span class="ek-vh"> je Stück</span></span>';
        }
        html += '<label class="ek-tier' + (bogen ? ' ek-tiers--4' : '') + (t.available ? '' : ' is-off') + '">' +
          '<input class="ek-vh" type="radio" name="' + name + '" value="' + t.k2 + '"' + (t.available ? '' : ' disabled') + '>' +
          cells + '<span class="ek-tier__sum">' + eur(price) + '<span class="ek-vh"> gesamt</span></span></label>';
      });
      /* große Formate gibt es nicht in allen Mengen (Gewicht und Versand): Hinweis auf größere Mengen */
      if (!bogen && r.mat) {
        var here = r.tiers[r.tiers.length - 1].k2;
        var most = 0;
        r.mat.rows.forEach(function (x) { if ((!r.cut || !x.cut || x.cut === r.cut) && x.k2 > most) most = x.k2; });
        if (most > here) html += '<p class="ek-tiers__more">Mehr als ' + int(here) + ' Stück in dieser Größe auf Anfrage.</p>';
      }
      box.innerHTML = html;
    }
    Array.prototype.forEach.call(box.querySelectorAll('input[name="qty"]'), function (inp) {
      var on = parseInt(inp.value, 10) === r.qty;
      inp.checked = on;
      inp.parentNode.classList.toggle('is-active', on);
    });
  };

  /* Datencheck und Layout-Service ohne gewählte Variante, z. B. wenn das gewählte Material das Maß nicht hat */
  Configurator.prototype.extraPrice = function () {
    var x = this.cfg.check ? this.cfg.check.price : 0;
    var lay = this.field('layout');
    if (lay && lay.checked && this.cfg.layout) x += this.cfg.layout.price;
    return x;
  };

  Configurator.prototype.renderMatPrices = function (r) {
    var self = this;
    var bogen = this.mode === 'bogen';
    /* Hat das gewählte Material das Maß nicht (z. B. Papier über 250 mm), zeigen die anderen Karten ihren Preis für die
       gewünschte Menge; bei ungültigem Maß bleiben die Karten wie bisher leer */
    var qty = isFinite(r.qty) ? r.qty : (r.matLimit ? this.wantQty : NaN);
    var extra = isFinite(r.extra) ? r.extra : this.extraPrice();
    /* Flächenstufe je Material: nicht jedes Material gibt es in jeder Größe (z. B. Papier nur bis 250 mm) */
    function classFor(m) {
      if (bogen) return r.sheet;
      if (!(r.area > 0)) return undefined;
      var ks = uniqSorted(m.rows.filter(function (x) { return !r.cut || !x.cut || x.cut === r.cut; })
        .map(function (x) { return x.k1; }));
      for (var i = 0; i < ks.length; i++) if (ks[i] + 1e-9 >= r.area) return ks[i];
      return undefined;
    }
    function priceText(m) {
      if (!bogen && m.maxMm && r.area > 0 && Math.max(r.w, r.h) > m.maxMm) return 'bis ' + int(m.maxMm) + ' mm';
      if (self.mode === 'gross' && m.rectOnly && r.cut !== 'gerade' && r.area > 0) return 'nur rechteckig';
      var k1 = classFor(m);
      var row = null;
      var most = 0;
      if (k1 !== undefined && isFinite(qty)) {
        for (var i = 0; i < m.rows.length; i++) {
          var x = m.rows[i];
          if (x.k1 !== k1 || (r.cut && x.cut && x.cut !== r.cut)) continue;
          if (x.k2 > most) most = x.k2;
          if (x.k2 === qty && !row) row = x;
        }
      }
      if (row) return eur(self.shown(row.price + extra));
      if (bogen && k1 && !m.rows.some(function (x) { return x.k1 === k1; })) return 'nicht als ' + r.sheetLabel;
      if (most && qty > most) return 'bis ' + int(most) + ' Stück';
      return '';
    }
    this.materials.forEach(function (m) {
      var el = self.root.querySelector('[data-ek-matprice="' + m.key + '"]');
      if (el) el.textContent = priceText(m);
    });
    /* Karte einer Gruppe: Preis des Materials, das ein Klick auf die Karte wählen würde */
    (this.groups || []).forEach(function (g) {
      var el = self.root.querySelector('[data-ek-grpprice="' + g.key + '"]');
      var m = self.groupPick(g);
      if (el) el.textContent = m ? priceText(m) : '';
    });
  };

  /* Lage von Aufkleber und Vergleichsobjekt in der Vorschau, in Prozent der Bühne (Rand 13 %) */
  function stageLayout(w, h, ref) {
    if (!ref) {
      var maxd = Math.max(w, h);
      return { sw: w / maxd * 100, sh: h / maxd * 100, sx: 50, sy: 50 };
    }
    var th = Math.max(h, ref.h);
    /* bei hohen, schmalen Aufklebern mehr Abstand, damit Maß und Beschriftung des Vergleichs nicht übereinanderliegen */
    var gap = Math.max(6, 0.08 * (w + ref.w), 0.48 * th - (w + ref.w) / 2);
    var tw = w + gap + ref.w;
    var k = 1 / Math.max(tw, th);
    var left = (1 - tw * k) / 2;
    var bottom = (1 + th * k) / 2;
    return {
      sw: w * k * 100, sh: h * k * 100, sx: (left + w * k / 2) * 100, sy: (bottom - h * k / 2) * 100,
      rw: ref.w * k * 100, rh: ref.h * k * 100, rx: (left + (w + gap + ref.w / 2) * k) * 100, ry: (bottom - ref.h * k / 2) * 100
    };
  }

  /* Schneidkontur für freie Kontur (ek-druckcheck.js), je Datei und Maß nur einmal berechnet */
  Configurator.prototype.cutFor = function (info, r) {
    var dc = window.EkDruckcheck;
    if (!dc || !info || !info.alpha || info.alpha.empty || !(r.w > 2 * GAP) || !(r.h > 2 * GAP)) return null;
    var key = this.anaToken + '|' + r.w + '|' + r.h;
    if (this.cutKey === key) return this.cut;
    this.cutKey = key;
    try { this.cut = dc.contour(info, r.w, r.h, GAP); } catch (e) { this.cut = null; }
    return this.cut;
  };

  Configurator.prototype.renderSticker = function (r) {
    var st = this.el.sticker;
    if (!st) return;
    var w = isFinite(r.w) && r.w > 0 ? r.w : 50;
    var h = isFinite(r.h) && r.h > 0 ? r.h : w;
    var ref = REFS[this.cmp] || null;
    var lay = stageLayout(w, h, ref);
    st.style.width = lay.sw + '%';
    st.style.height = lay.sh + '%';
    st.style.left = lay.sx + '%';
    st.style.top = lay.sy + '%';
    st.setAttribute('data-shape', r.shape);
    st.setAttribute('data-swatch', r.mat ? r.mat.swatch : 'white_gloss');
    if (r.shape === 'abgerundet') {
      var rr = 0.12 * Math.min(w, h);
      st.style.borderRadius = (rr / w * 100) + '% / ' + (rr / h * 100) + '%';
    } else {
      st.style.borderRadius = '';
    }
    var img = this.el.img;
    var first = this.urls[0];
    if (img) {
      if (first) {
        if (img.getAttribute('src') !== first.url) img.setAttribute('src', first.url);
        img.hidden = false;
      } else {
        img.removeAttribute('src');
        img.hidden = true;
      }
    }
    st.classList.toggle('has-img', !!first);
    if (this.el.ph) this.el.ph.hidden = !!first;

    /* Freie Kontur mit Bild: Schneidlinie aus dem Motiv berechnen */
    var info = first ? this.analysis[0] : null;
    var cut = r.shape === 'frei' && info && !info.pending && !r.sizeError ? this.cutFor(info, { w: w, h: h }) : null;
    var svg = st.querySelector('.ek-sticker__cut');
    if (cut) {
      if (!svg) {
        svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('class', 'ek-sticker__cut');
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');
        st.appendChild(svg);
      }
      var sig = cut.path.length + '|' + first.url + '|' + w + '|' + h;
      if (svg.getAttribute('data-sig') !== sig) {
        svg.setAttribute('data-sig', sig);
        svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
        var im = cut.img;
        svg.innerHTML = '<path class="ek-cut__fill" d="' + cut.path + '"/>' +
          '<image href="' + esc(first.url) + '" x="' + im.x.toFixed(2) + '" y="' + im.y.toFixed(2) + '" width="' + im.w.toFixed(2) +
          '" height="' + im.h.toFixed(2) + '" preserveAspectRatio="none"/>' +
          '<path class="ek-cut__line" d="' + cut.path + '"/>';
      }
    } else if (svg) {
      svg.parentNode.removeChild(svg);
    }
    st.classList.toggle('has-cut', !!cut);

    /* Vergleichsobjekt */
    var refEl = this.el.ref;
    if (refEl) {
      refEl.hidden = !ref;
      if (ref) {
        refEl.setAttribute('data-kind', this.cmp);
        refEl.style.width = lay.rw + '%';
        refEl.style.height = lay.rh + '%';
        refEl.style.left = lay.rx + '%';
        refEl.style.top = lay.ry + '%';
        if (this.el.reflabel) this.el.reflabel.textContent = ref.label;
      }
    }
    var size = r.round ? 'Ø ' + mm(w) + ' mm' : mm(w) + ' × ' + mm(h) + ' mm';
    if (this.el.dimw) {
      this.el.dimw.textContent = ref ? size : (r.round ? 'Ø ' + mm(w) + ' mm' : mm(w) + ' mm');
      /* mit Vergleich steht das Maß unter dem Aufkleber */
      this.el.dimw.style.left = ref ? (13 + 0.74 * lay.sx) + '%' : '';
      this.el.dimw.style.bottom = ref ? (100 - (13 + 0.74 * (lay.sy + lay.sh / 2)) - 7) + '%' : '';
    }
    if (this.el.dimh) {
      this.el.dimh.textContent = mm(h) + ' mm';
      this.el.dimh.hidden = r.round || !!ref;
    }
    if (this.el.stage) {
      this.el.stage.setAttribute('data-swatch', r.mat ? r.mat.swatch : '');
      this.el.stage.classList.toggle('is-compare', !!ref);
    }
    if (this.el.pmeta) this.el.pmeta.textContent = r.area ? int(r.area) + ' cm²' : '';
    if (this.el.pnote) {
      var note;
      if (cut && cut.mode === 'box') note = 'Gestrichelt: die Schneidkontur. Ihr Bild hat keinen transparenten Hintergrund, deshalb wird mit etwa 2 mm Abstand rechteckig um das Bild geschnitten.';
      else if (cut) note = 'Gestrichelt: so verläuft die Schneidkontur, etwa 2 mm um Ihr Motiv. Die genaue Kontur sehen Sie in der PDF-Vorschau vor dem Druck.';
      else if (r.shape === 'frei') note = 'Bei freier Kontur wird mit etwa 2 mm Abstand um Ihr Motiv geschnitten. Die genaue Kontur sehen Sie in der PDF-Vorschau vor dem Druck.';
      else if (this.mode === 'rolle' && r.shape === 'rechteck') note = 'Rechteckige Etiketten werden gerade geschnitten. Die genaue Lage sehen Sie in der PDF-Vorschau vor dem Druck.';
      else if (this.mode === 'magnet' && r.shape === 'rechteck') note = 'Rechteckige Magnete werden gerade geschnitten. Die genaue Lage sehen Sie in der PDF-Vorschau vor dem Druck.';
      else if (this.mode === 'gross' && r.shape === 'rechteck' && r.mat && r.mat.rectOnly) note = r.mat.label + ' wird gerade geschnitten. Die genaue Lage sehen Sie in der PDF-Vorschau vor dem Druck.';
      else note = 'Geschnitten wird entlang der gewählten Form. Die genaue Lage sehen Sie in der PDF-Vorschau vor dem Druck.';
      if (ref) note += ' Zum Vergleich daneben: ' + ref.label + '.';
      this.el.pnote.textContent = note;
    }
  };

  /* Rolle: Etiketten mit Ihrem Motiv in der gewählten Wickelrichtung */
  Configurator.prototype.renderRoll = function (r) {
    var svg = this.el.roll;
    if (!svg) return;
    var w = isFinite(r.w) && r.w > 0 && !r.sizeError ? r.w : 50;
    var h = isFinite(r.h) && r.h > 0 && !r.sizeError ? r.h : (r.round ? w : 30);
    var first = this.urls[0];
    var img = first ? first.url : '';
    var sw = r.mat ? r.mat.swatch : 'white_gloss';
    var sig = [r.wind, w, h, r.shape, sw, img].join('|');
    if (svg.getAttribute('data-sig') === sig) return;
    svg.setAttribute('data-sig', sig);
    if (!this.rollId) this.rollId = 'ekr' + Math.random().toString(36).slice(2, 7);
    svg.innerHTML = rollSvg({ W: 320, H: 132, n: r.wind, w: w, h: h, shape: r.shape, swatch: sw, img: img, id: this.rollId });
    var info = windInfo(r.wind);
    svg.setAttribute('aria-label', 'Rollenskizze, Wickelrichtung ' + windText(r.wind) +
      (info.side === 'innen' ? ', die Etiketten liegen auf der Unterseite der Bahn' : ''));
    svg.setAttribute('data-side', info.side === 'innen' ? 'innen' : 'aussen');
  };

  Configurator.prototype.renderSheet = function (r) {
    var svg = this.el.sheet;
    if (!svg) return;
    var SW = r.dims[0];
    var SH = r.dims[1];
    var m = this.cfg.limits.margin;
    var L = r.layout;
    var out = '<rect class="ek-sheet__paper" x="0" y="0" width="' + SW + '" height="' + SH + '"/>' +
      '<rect class="ek-sheet__margin" x="' + m + '" y="' + m + '" width="' + (SW - 2 * m) + '" height="' + (SH - 2 * m) + '"/>';
    var defs = '';
    var imgs = this.urls;
    if (imgs.length) {
      imgs.forEach(function (u, i) {
        defs += '<pattern id="ek-pat-' + i + '" patternContentUnits="objectBoundingBox" width="1" height="1">' +
          '<rect width="1" height="1" fill="#fff"/>' +
          '<image href="' + esc(u.url) + '" x="0.06" y="0.06" width="0.88" height="0.88" preserveAspectRatio="xMidYMid meet"/></pattern>';
      });
    }
    if (L && L.n) {
      var gx = r.gx;
      var gy = r.gy;
      var usedW = L.cols * L.a + (L.cols - 1) * gx;
      var usedH = L.rows * L.b + (L.rows - 1) * gy;
      var ox = (SW - usedW) / 2;
      var oy = (SH - usedH) / 2;
      var cap = Math.min(L.n, 1500);
      var motifs = r.motifs || 1;
      var rx = r.shape === 'abgerundet' ? Math.min(L.a, L.b) * 0.12 : (r.shape === 'rechteck' ? 0.4 : 0);
      var ellipse = r.shape === 'rund' || r.shape === 'oval';
      for (var i = 0; i < cap; i++) {
        var row = Math.floor(i / L.cols);
        var col = i % L.cols;
        var x = ox + col * (L.a + gx);
        var y = oy + row * (L.b + gy);
        var motif = i % motifs;
        var fill = imgs.length ? 'url(#ek-pat-' + (motif % imgs.length) + ')' : FILLS[motif % FILLS.length];
        if (ellipse) {
          out += '<ellipse class="ek-sheet__lbl" cx="' + (x + L.a / 2).toFixed(2) + '" cy="' + (y + L.b / 2).toFixed(2) +
            '" rx="' + (L.a / 2).toFixed(2) + '" ry="' + (L.b / 2).toFixed(2) + '" fill="' + fill + '"/>';
        } else {
          out += '<rect class="ek-sheet__lbl" x="' + x.toFixed(2) + '" y="' + y.toFixed(2) + '" width="' + L.a.toFixed(2) +
            '" height="' + L.b.toFixed(2) + '" rx="' + rx.toFixed(2) + '" fill="' + fill + '"/>';
        }
      }
    }
    svg.setAttribute('viewBox', '0 0 ' + SW + ' ' + SH);
    svg.style.aspectRatio = SW + ' / ' + SH;
    svg.innerHTML = (defs ? '<defs>' + defs + '</defs>' : '') + out;
    svg.setAttribute('aria-label', 'Bogenvorschau ' + r.sheetLabel + (L && L.n ? ', ' + L.n + ' Etiketten je Bogen' : ''));
    if (this.el.pmeta) this.el.pmeta.textContent = r.sheetLabel + ' · ' + mm(SW) + ' × ' + mm(SH) + ' mm';
    if (this.el.pnote) {
      if (L && L.n) {
        this.el.pnote.innerHTML = '<strong>' + L.n + ' ' + plural(L.n, 'Etikett', 'Etiketten') + ' je Bogen</strong> (' + L.cols + ' × ' + L.rows + ')' +
          (L.rotated ? ', quer angeordnet, so passen mehr auf den Bogen' : '') +
          '. Randabstand ' + m + ' mm. Die genaue Lage sehen Sie in der PDF-Vorschau vor dem Druck.';
      } else {
        this.el.pnote.textContent = r.sizeError ? r.reason : '';
      }
    }
  };

  Configurator.prototype.renderFilesUi = function () {
    var later = this.val('files') === 'later';
    if (this.el.drop) this.el.drop.hidden = later;
    if (this.el.later) this.el.later.hidden = !later;
  };

  Configurator.prototype.summaryRows = function (r) {
    var rows = [];
    var size = r.round ? 'Ø ' + mm(r.w) + ' mm' : mm(r.w) + ' × ' + mm(r.h) + ' mm';
    if (r.mode === 'bogen') {
      rows.push(['Bogen', r.sheetLabel]);
      rows.push(['Form', SHAPE_LABEL[r.shape] || r.shape]);
      if (isFinite(r.w) && isFinite(r.h)) rows.push(['Etikettenmaß', size]);
      if (r.gx || r.gy) rows.push(['Abstände', mm(r.gx) + ' / ' + mm(r.gy) + ' mm']);
      if (r.per) rows.push(['Etiketten je Bogen', String(r.per)]);
      if (r.mat) rows.push(['Material', r.mat.label]);
      rows.push(['Motive', String(r.motifs || 1)]);
    } else {
      rows.push(['Form', SHAPE_LABEL[r.shape] || r.shape]);
      if (isFinite(r.w) && isFinite(r.h)) rows.push(['Maß', size]);
      if (r.mat) rows.push(['Material', r.mat.label]);
      if (r.mode === 'rolle') {
        rows.push(['Wickelrichtung', windText(r.wind)]);
        rows.push(['Abstand auf der Rolle', ROLL_GAP + ' mm']);
      }
      if (r.mode === 'magnet' && r.cut) rows.push(['Schnitt', r.cut === 'kontur' ? 'Konturschnitt' : 'gerade']);
      if (r.mode === 'gross' && r.cut) rows.push(['Schnitt', r.cut === 'kontur' || (r.mat && !r.mat.cuts.length) ? 'Konturschnitt' : 'gerade']);
      if (r.cls) rows.push(['Preisstufe', 'bis ' + int(r.cls) + ' cm²']);
    }
    return rows;
  };

  Configurator.prototype.inquiryHref = function (r) {
    var lines = ['Guten Tag,', '', 'bitte erstellen Sie mir ein Angebot für ' + this.cfg.productName + ':', ''];
    this.summaryRows(r).forEach(function (row) { lines.push(row[0] + ': ' + row[1]); });
    lines.push('Menge: ', '', 'Mein Wunsch:', '', '');
    var subject = 'Anfrage ' + this.cfg.productName;
    return 'mailto:' + this.cfg.inquiryEmail + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(lines.join('\n'));
  };

  Configurator.prototype.renderPrice = function (r) {
    var el = this.el;
    var bogen = this.mode === 'bogen';
    var has = !!r.variant;
    if (el.price) el.price.textContent = has ? eur(this.shown(r.total)) : 'Auf Anfrage';
    if (el.mbarprice) el.mbarprice.textContent = has ? eur(this.shown(r.total)) : 'Auf Anfrage';
    if (el.tax) {
      var t = el.tax;
      if (!t.getAttribute('data-gross')) t.setAttribute('data-gross', t.innerHTML);
      t.innerHTML = this.b2b ? 'netto, zzgl. 19 % MwSt. und Versand' : t.getAttribute('data-gross');
    }
    if (el.ship) {
      var sh = el.ship;
      if (!sh.getAttribute('data-gross')) sh.setAttribute('data-gross', sh.textContent);
      var shNet = sh.getAttribute('data-net');
      sh.textContent = this.b2b && shNet ? shNet : sh.getAttribute('data-gross');
    }
    if (el.qtyline) {
      if (has && bogen) {
        el.qtyline.textContent = int(r.qty) + ' Bogen · ' + int(r.units) + ' Etiketten · ' + eurUnit(this.shown(r.total) / r.units) + ' je Etikett';
      } else if (has) {
        el.qtyline.textContent = int(r.qty) + ' Stück · ' + eurUnit(this.shown(r.total) / r.qty) + ' je Stück';
      } else {
        el.qtyline.textContent = r.reason || '';
      }
    }
    if (el.lines) {
      if (has && r.addons.length) {
        var self = this;
        var html = '<li><span>' + esc(this.item()) + '</span><span>' + eur(this.shown(r.variant.price)) + '</span></li>';
        r.addons.forEach(function (a) { html += '<li><span>' + esc(a.label) + '</span><span>' + eur(self.shown(a.price)) + '</span></li>'; });
        el.lines.innerHTML = html;
        el.lines.hidden = false;
      } else {
        el.lines.innerHTML = '';
        el.lines.hidden = true;
      }
    }
    var d = this.cfg.delivery;
    if (el.date) el.date.textContent = DATE.format(deliveryDate(d.std, d.cutoff, this.holidays));
    if (el.express) el.express.textContent = d.showExpress ? 'Mit Express voraussichtlich ' + DATE.format(deliveryDate(d.exp, d.cutoff, this.holidays)) + ', gegen Aufpreis' : '';
    if (el.summary) {
      el.summary.innerHTML = this.summaryRows(r).map(function (row) {
        return '<div><dt>' + esc(row[0]) + '</dt><dd>' + esc(row[1]) + '</dd></div>';
      }).join('');
    }
    var href = this.inquiryHref(r);
    this.inquiryLinks.forEach(function (a) { a.setAttribute('href', href); });
    var buttons = this.form.querySelectorAll('button[type="submit"]');
    Array.prototype.forEach.call(buttons, function (b) { b.setAttribute('aria-disabled', r.ok ? 'false' : 'true'); });
    if (r.ok) this.showMsg(el.error, '');
    var self2 = this;
    var said = this.priceText(r);
    window.clearTimeout(this.liveTimer);
    if (!this.liveReady) {
      /* beim Laden nichts ansagen */
      this.liveReady = true;
      this.lastLive = said;
      return;
    }
    if (!said || said === this.lastLive) return;
    this.liveTimer = window.setTimeout(function () {
      self2.lastLive = said;
      if (el.live) el.live.textContent = said;
    }, 700);
  };

  /* ---------- Spartipp ---------- */
  Configurator.prototype.renderTip = function (r) {
    var el = this.el.tip;
    if (!el) return;
    var bogen = this.mode === 'bogen';
    var i = -1;
    for (var k = 0; k < r.tiers.length; k++) if (r.tiers[k].k2 === r.qty) { i = k; break; }
    var next = i >= 0 ? r.tiers.slice(i + 1).filter(function (t) { return t.available; })[0] : null;
    if (!r.variant || !next) { this.showMsg(el, ''); return; }
    var per = Math.max(1, r.per || 1);
    var units = function (t) { return bogen ? t.k2 * per : t.k2; };
    var cur = r.variant;
    var fix = r.extra || 0;
    var uc = (cur.price + fix) / units(cur);
    var un = (next.price + fix) / units(next);
    var extra = next.price - cur.price;
    if (!(un < uc * 0.75) || extra < 0 || extra > (cur.price + fix) * 0.6) { this.showMsg(el, ''); return; }
    var qn = int(next.k2) + (bogen ? ' Bogen' : ' Stück');
    var qc = int(cur.k2) + (bogen ? ' Bogen' : ' Stück');
    var lead = extra < 1 ? 'Zum gleichen Preis' : 'Für ' + eur(this.shown(extra)) + ' mehr';
    var txt = 'Tipp: ' + lead + ' bekommen Sie ' + qn + (bogen ? ' (' + int(units(next)) + ' Etiketten)' : '') + ' statt ' + qc + '. Das sind ' +
      eurUnit(this.shown(un)) + ' statt ' + eurUnit(this.shown(uc)) + (bogen ? ' je Etikett.' : ' je Stück.');
    el.innerHTML = '<span>' + esc(txt) + '</span> <button type="button" class="ek-tip__btn" data-ek-qty="' + next.k2 + '">' + esc(qn) + ' wählen</button>';
    el.hidden = false;
  };

  /* ---------- Schnellcheck der Druckdaten ---------- */
  function itemHtml(it) {
    var st = it.st || 'info';
    var icon = ICONS[st === 'bad' ? 'warn' : st] || ICONS.info;
    var btn = '';
    if (it.fit) btn = ' <button type="button" class="ek-pre__btn" data-ek-fit data-w="' + it.fit[0] + '" data-h="' + it.fit[1] + '">' + esc(it.fitLabel) + '</button>';
    else if (it.motifs) btn = ' <button type="button" class="ek-pre__btn" data-ek-motifset="' + it.motifs + '">' + esc(it.motifsLabel) + '</button>';
    return '<li class="ek-pre__item ek-pre__item--' + st + '"><span class="ek-pre__icon">' + icon + '</span><span class="ek-pre__txt">' +
      '<span class="ek-vh">' + STATUS_TXT[st] + '</span><strong>' + esc(it.title) + '</strong>' + (it.text ? ' ' + esc(it.text) : '') + btn + '</span></li>';
  }

  /* Ergebnis des Schnellchecks einmal ansagen, nicht bei jeder Eingabe */
  Configurator.prototype.announceChecks = function () {
    var r = this.current;
    if (!r) return;
    var self = this;
    var n = { ok: 0, warn: 0, bad: 0, info: 0 };
    this.analysis.forEach(function (a) { self.checksFor(a, r).forEach(function (it) { n[it.st] = (n[it.st] || 0) + 1; }); });
    var parts = [];
    if (n.bad) parts.push(n.bad + (n.bad === 1 ? ' Problem' : ' Probleme'));
    if (n.warn) parts.push(n.warn + (n.warn === 1 ? ' Hinweis' : ' Hinweise'));
    if (n.ok) parts.push(n.ok + ' in Ordnung');
    this.say('Schnellcheck der Druckdaten fertig' + (parts.length ? ': ' + parts.join(', ') : '') + '. Details stehen unter dem Datei-Feld.');
  };

  /* Maß so ändern, dass das Seitenverhältnis zum Motiv passt (auf 0,5 mm gerundet, in den Grenzen) */
  Configurator.prototype.fitTo = function (aspect, r) {
    if (!(aspect > 0) || !isFinite(r.w) || !isFinite(r.h)) return null;
    var lim = this.cfg.limits;
    var g = r.shape === 'frei' ? 2 * GAP : 0;
    var half = function (v) { return Math.round(v * 2) / 2; };
    var max = this.mode === 'bogen' ? 1000 : lim.max;
    var w = r.w;
    var h = half((w - g) / aspect + g);
    if (h > max) { h = max; w = half((h - g) * aspect + g); }
    if (h < lim.min) { h = lim.min; w = half((h - g) * aspect + g); }
    if (w < lim.min || w > max || h < lim.min || h > max) return null;
    if (lim.minLong && Math.max(w, h) < lim.minLong) return null;
    if (this.mode !== 'bogen' && lim.maxShort && Math.min(w, h) > lim.maxShort) return null;
    if (Math.abs(w - r.w) < 0.05 && Math.abs(h - r.h) < 0.05) return null;
    return [w, h];
  };

  Configurator.prototype.checksFor = function (info, r) {
    var out = [];
    var dc = window.EkDruckcheck;
    if (!info || !dc) return out;
    var bogen = this.mode === 'bogen';
    var stk = this.mode === 'aufkleber' || this.mode === 'gross';
    var label = stk ? 'Ihr Aufkleber' : (this.mode === 'magnet' ? 'Ihr Magnet' : 'Ihr Etikett');
    var labelAcc = stk ? 'Ihren Aufkleber' : (this.mode === 'magnet' ? 'Ihren Magneten' : 'Ihr Etikett');
    var frei = r.shape === 'frei';
    var hasSize = isFinite(r.w) && isFinite(r.h) && r.w > 0 && r.h > 0;
    var sizeTxt = r.round ? 'Ø ' + mm(r.w) + ' mm' : mm(r.w) + ' × ' + mm(r.h) + ' mm';

    if (info.problem === 'read') return [{ st: 'info', title: 'Keine Vorschau möglich', text: 'Ihr Browser kann die Datei nicht anzeigen. Wir prüfen sie beim Datencheck.' }];
    if (info.problem === 'empty') return [{ st: 'bad', title: 'Bild ist leer', text: 'Die Datei enthält nur transparente Pixel. Bitte prüfen Sie den Export.' }];
    if (info.problem === 'pdf') return [{ st: 'warn', title: 'PDF nicht erkannt', text: 'Die Datei sieht nicht wie ein PDF aus. Bitte prüfen Sie den Export.' }];
    if (info.problem === 'svg') return [{ st: 'warn', title: 'SVG nicht lesbar', text: 'Die Datei lässt sich nicht als SVG lesen. Bitte prüfen Sie den Export.' }];
    if (info.problem === 'eps') return [{ st: 'warn', title: 'EPS nicht erkannt', text: 'Die Datei sieht nicht wie eine EPS-Datei aus. Bitte prüfen Sie den Export.' }];
    if (info.problem === 'big') return [{ st: 'info', title: 'Prüfen wir beim Datencheck', text: 'Die Datei ist zu groß für den Schnellcheck im Browser. Wir prüfen sie und schicken Ihnen eine PDF-Vorschau.' }];

    var inW = frei ? r.w - 2 * GAP : r.w;
    var inH = frei ? r.h - 2 * GAP : r.h;

    /* Vektor oder Auflösung */
    if (info.vector) {
      if (info.kind === 'svg') {
        out.push(info.embedded
          ? { st: 'info', title: 'Vektorgrafik mit Bild', text: 'Linien und Schrift bleiben in jeder Größe scharf. Die Datei enthält auch ein Bild, dessen Auflösung prüfen wir beim Datencheck.' }
          : { st: 'ok', title: 'Vektorgrafik', text: 'Linien und Schrift bleiben in jeder Größe scharf.' });
      } else {
        var vname = info.ext === 'ai' ? 'Illustrator-Datei' : (info.ext === 'eps' ? 'EPS-Datei' : 'PDF');
        out.push({ st: 'info', title: vname, text: 'Vektoren bleiben in jeder Größe scharf. Enthaltene Bilder und Schriften prüfen wir beim Datencheck.' });
      }
    } else if (info.px && hasSize && inW > 0 && inH > 0) {
      var fitted = dc.fitBox(info.aspect, inW, inH);
      var d = dc.dpi(info, fitted[0], fitted[1]);
      if (d) {
        var dt = 'Etwa ' + int(Math.round(d / 10) * 10) + ' dpi bei ' + mm(fitted[0]) + ' × ' + mm(fitted[1]) + ' mm Motivgröße.';
        var mp = info.motifPx || info.px;
        if (d >= 250) out.push({ st: 'ok', title: 'Auflösung passt', text: dt });
        else if (d >= 150) out.push({ st: 'warn', title: 'Auflösung knapp', text: dt + ' Feine Linien und kleine Schrift können weich wirken. Für 300 dpi wäre das Motiv höchstens ' + mm(Math.floor(mp[0] / 300 * 25.4)) + ' × ' + mm(Math.floor(mp[1] / 300 * 25.4)) + ' mm groß.' });
        else out.push({ st: 'bad', title: 'Auflösung zu gering', text: dt + ' Das Motiv wird unscharf. Besser ist eine größere Datei oder eine Vektordatei (PDF, SVG, AI, EPS).' });
      }
    }

    /* Format von PDF, AI, EPS und SVG mit Maßeinheit */
    var page = info.kind !== 'raster' ? (info.trim || info.mm) : null;
    var pageDone = false;
    if (page && hasSize) {
      var near = function (a, b) { return Math.abs(a - b) <= 0.6; };
      var pw = page[0];
      var ph = page[1];
      var pageTxt = (info.trim ? 'Endformat ' : (info.kind === 'pdf' ? 'Seite ' : 'Grafik ')) + mm(pw) + ' × ' + mm(ph) + ' mm';
      if (frei && near(pw, inW) && near(ph, inH)) {
        out.push({ st: 'ok', title: 'Format passt', text: pageTxt + ': Ihr Motiv, die Schneidkontur kommt mit 2 mm Abstand dazu.' });
        pageDone = true;
      } else if (info.trim && near(pw, r.w) && near(ph, r.h)) {
        out.push({ st: 'ok', title: 'Format passt', text: pageTxt + ' wie ' + label + (info.mm && info.mm[0] > pw + 3 ? ', mit Beschnitt.' : '.') });
        pageDone = true;
      } else if (!info.trim && near(pw, r.w + 4) && near(ph, r.h + 4)) {
        out.push({ st: 'ok', title: 'Format passt', text: pageTxt + ': Ihr Maß mit 2 mm Beschnitt rundum.' });
        pageDone = true;
      } else if (near(pw, r.w) && near(ph, r.h)) {
        out.push({ st: frei ? 'ok' : 'info', title: frei ? 'Format passt' : 'Format passt, ohne Beschnitt', text: pageTxt + ' wie ' + label + '.' +
          (frei ? '' : ' Reicht Ihr Motiv bis an den Rand, legen Sie rundum 2 mm Beschnitt an.') });
        pageDone = true;
      } else if (!r.round && ((near(pw, r.h) && near(ph, r.w)) || (near(pw, r.h + 4) && near(ph, r.w + 4)))) {
        out.push({ st: 'warn', title: 'Hoch und quer vertauscht?', text: pageTxt + ', ' + label + ' ' + sizeTxt + '.', fit: [r.h, r.w], fitLabel: 'Maß auf ' + mm(r.h) + ' × ' + mm(r.w) + ' mm drehen' });
        pageDone = true;
      } else {
        var a1 = pw / ph;
        var a2 = pw > 5 && ph > 5 ? (pw - 4) / (ph - 4) : a1;
        var target = inW > 0 && inH > 0 ? inW / inH : r.w / r.h;
        var same = Math.abs(a1 / target - 1) <= 0.03 || Math.abs(a2 / target - 1) <= 0.03;
        if (same) {
          out.push({ st: 'info', title: 'Anderes Maß', text: pageTxt + ', ' + label + ' ' + sizeTxt + '. Das Seitenverhältnis passt, Vektoren bleiben beim Skalieren scharf.' });
          pageDone = true;
        } else if (r.round) {
          out.push({ st: 'info', title: this.mode === 'magnet' ? 'Runder Magnet' : 'Rundes Etikett', text: pageTxt + ', ' + label + ' ' + sizeTxt + '. Wir passen das Motiv in den Kreis ein. Wie es wirkt, sehen Sie in der PDF-Vorschau.' });
          pageDone = true;
        } else {
          var fit = this.fitTo(a1, r);
          out.push({ st: 'warn', title: 'Format weicht ab', text: pageTxt + ', ' + label + ' ' + sizeTxt + '. Wir prüfen beim Datencheck, wie das Motiv auf ' + labelAcc + ' passt.',
            fit: fit, fitLabel: fit ? 'Maß auf ' + mm(fit[0]) + ' × ' + mm(fit[1]) + ' mm anpassen' : '' });
          pageDone = true;
        }
      }
    }

    /* Seitenverhältnis von Bildern und SVG ohne Maßeinheit */
    if (!pageDone && hasSize && info.aspect && (info.kind === 'raster' || info.kind === 'svg' || info.kind === 'tif')) {
      var ma = info.aspect;
      if (r.round) {
        if (Math.abs(ma - 1) > 0.15) out.push({ st: 'info', title: 'Rundes Etikett', text: 'Ihr Motiv ist ' + dc.ratioText(ma) + ' ' + (ma > 1 ? 'quer' : 'hoch') + '. In der Vorschau ist es in den Kreis eingepasst.' });
      } else if (inW > 0 && inH > 0) {
        var sa = inW / inH;
        if (Math.abs(ma / sa - 1) > 0.03) {
          var f2 = this.fitTo(ma, r);
          var orient = function (a) { return a > 1.03 ? ' quer' : (a < 0.97 ? ' hoch' : ''); };
          out.push({ st: 'warn', title: 'Seitenverhältnis weicht ab',
            text: 'Ihr Motiv ist ' + dc.ratioText(ma) + orient(ma) + ', ' + (frei ? 'die Fläche innerhalb der Kontur ' : label + ' ') + dc.ratioText(sa) + orient(sa) + '. Eingepasst bleibt ' + (ma > sa ? 'oben und unten' : 'links und rechts') + ' Rand.',
            fit: f2, fitLabel: f2 ? 'Maß auf ' + mm(f2[0]) + ' × ' + mm(f2[1]) + ' mm anpassen' : '' });
        }
      }
    }

    /* Transparenz bei freier Kontur */
    if (frei && !bogen && (info.kind === 'raster' || info.kind === 'svg') && info.alpha) {
      if (info.alpha.transparent) {
        var c = hasSize && !r.sizeError ? this.cutFor(info, r) : null;
        if (c && c.mode === 'hull') out.push({ st: 'info', title: 'Mehrere Teile', text: 'Ihr Motiv besteht aus Teilen, die weit auseinanderliegen. Geschnitten wird um alle Teile gemeinsam. Die genaue Kontur sehen Sie in der PDF-Vorschau.' });
        else out.push({ st: 'ok', title: 'Freigestellt', text: 'Der Hintergrund ist transparent. Die Schneidkontur folgt Ihrem Motiv.' });
      } else {
        out.push({ st: 'info', title: 'Mit Hintergrund', text: 'Ihr Bild hat keinen transparenten Hintergrund, deshalb wird rechteckig um das Bild geschnitten. Für eine Kontur um das Motiv eignet sich ein PNG mit transparentem Hintergrund oder ein PDF mit Schneidkontur.' });
      }
    }

    /* Farben */
    if (info.cmyk === true) out.push({ st: 'ok', title: 'CMYK', text: 'Die Datei ist in CMYK angelegt, wie es für den Druck üblich ist.' });
    else if (info.gray) out.push({ st: 'info', title: 'Graustufen', text: 'Gedruckt wird in Schwarz und Grautönen.' });
    else if (info.cmyk === false) out.push({ st: 'info', title: 'RGB-Farben', text: 'Wir wandeln die Farben für den Druck in CMYK um. Sehr leuchtende Bildschirmfarben wirken gedruckt etwas ruhiger.' });

    /* Formate ohne Vorschau */
    if (info.kind === 'other' || (info.kind === 'tif' && !info.px) || (info.kind === 'eps' && !info.mm) || (info.kind === 'pdf' && !info.mm)) {
      out.push({ st: 'info', title: 'Prüfen wir beim Datencheck', text: 'Für diese Datei zeigen wir hier keine Vorschau. Wir prüfen sie und schicken Ihnen eine PDF-Vorschau.' });
    }
    if (bogen && info.kind === 'pdf' && info.pages > 1) out.push({ st: 'info', title: info.pages + ' Seiten', text: 'Je Seite ein Motiv.' });
    return out;
  };

  /* Bogen: passen Anzahl der Motive und Dateien (bzw. PDF-Seiten) zusammen? */
  Configurator.prototype.motifCheck = function (r, list) {
    if (list.some(function (a) { return !a || a.pending; })) return null;
    var multi = this.val('motifmode') === 'multi';
    var pages = 0;
    list.forEach(function (a) { pages += a.kind === 'pdf' && a.pages > 1 ? a.pages : 1; });
    pages = Math.min(pages, 50);
    var n = r.motifs || 1;
    var what = list.length > 1 ? list.length + ' Dateien' : 'ein PDF mit ' + pages + ' Seiten';
    if (!multi && pages > 1) {
      return { st: 'info', title: 'Mehrere Motive?', text: 'Sie haben ' + what + ' gewählt, aber „Ein Motiv“ eingestellt. Jedes weitere Motiv kostet einen kleinen Aufpreis.', motifs: pages, motifsLabel: 'Auf ' + pages + ' Motive stellen' };
    }
    if (multi && pages > n) {
      return { st: 'warn', title: 'Mehr Motive als angegeben', text: 'Sie haben ' + what + ' gewählt, aber ' + n + ' Motive angegeben.', motifs: pages, motifsLabel: 'Auf ' + pages + ' Motive stellen' };
    }
    if (multi && pages < n) {
      var have = list.length > 1 ? list.length + ' Dateien' : (pages > 1 ? '1 PDF mit ' + pages + ' Seiten' : '1 Datei');
      return { st: 'info', title: n + ' Motive, ' + have, text: 'Fehlende Motive können Sie nach der Bestellung mit Ihrer Bestellnummer per E-Mail senden.' };
    }
    return null;
  };

  Configurator.prototype.renderPreflight = function (r) {
    var box = this.el.pre;
    if (!box) return;
    var list = this.analysis;
    var upload = this.val('files') !== 'later';
    if (!upload || !list.length || !window.EkDruckcheck) {
      if (!box.hidden) { box.hidden = true; box.innerHTML = ''; }
      this.preKey = '';
      return;
    }
    var key = [this.anaToken, list.map(function (a) { return a && a.pending ? 'p' : 'd'; }).join(''), r.w, r.h, r.shape, r.mode, r.motifs,
      this.val('motifmode'), r.per].join('|');
    if (key === this.preKey) return;
    this.preKey = key;
    var self = this;
    var many = list.length > 1;
    var html = '<p class="ek-pre__title">Schnellcheck Ihrer ' + (many ? 'Dateien' : 'Datei') + '</p>';
    list.forEach(function (info) {
      var items = !info || info.pending ? [{ st: 'info', title: 'Wird geprüft …', text: '' }] : self.checksFor(info, r);
      html += '<div class="ek-pre__file">' + (many ? '<p class="ek-pre__name">' + esc(info ? info.name : '') + '</p>' : '') +
        '<ul class="ek-pre__list" role="list">' + items.map(itemHtml).join('') + '</ul></div>';
    });
    var mc = this.mode === 'bogen' ? this.motifCheck(r, list) : null;
    if (mc) html += '<ul class="ek-pre__list ek-pre__list--sum" role="list">' + itemHtml(mc) + '</ul>';
    html += '<p class="ek-pre__note">Der Schnellcheck läuft in Ihrem Browser. Die Datei wird erst übertragen, wenn Sie sie in den Warenkorb legen. Vor dem Druck prüfen wir sie und schicken Ihnen eine PDF-Vorschau.</p>';
    var focused = box.contains(document.activeElement);
    box.innerHTML = html;
    box.hidden = false;
    if (focused) box.focus();
  };

  /* ---------- Link zur Konfiguration ---------- */
  Configurator.prototype.configUrl = function (r, withHash) {
    var url;
    try { url = new URL(window.location.href); } catch (e) { return ''; }
    var q = url.searchParams;
    ['w', 'h', 'form', 'menge', 'anzahl', 'material', 'format', 'motive', 'abstand', 'wicklung'].forEach(function (k) { q.delete(k); });
    if (isFinite(r.w)) q.set('w', String(Math.round(r.w * 10) / 10));
    if (isFinite(r.h) && !r.round) q.set('h', String(Math.round(r.h * 10) / 10));
    if (r.shape) q.set('form', r.shape);
    if (isFinite(r.qty)) q.set('menge', String(r.qty));
    if (r.mat && r.mat.handle) q.set('material', r.mat.handle);
    if (r.mode === 'bogen') {
      var fmt = String(r.sheetLabel || '').replace(/^DIN\s*/i, '').trim();
      if (fmt) q.set('format', fmt);
      if (r.motifs > 1) q.set('motive', String(r.motifs));
      q.set('abstand', String(r.gx) + 'x' + String(r.gy));
    }
    if (r.mode === 'rolle' && WIND[r.wind]) q.set('wicklung', String(r.wind));
    if (withHash) url.hash = 'ek-konfigurator';
    return url.toString();
  };

  /* Adresse im Browser aktuell halten, damit Neuladen und Teilen die Auswahl behalten (nicht im Theme-Editor) */
  Configurator.prototype.syncUrl = function (r) {
    if (!this.touched || !r || !r.variant || !window.history || !history.replaceState) return;
    if (window.Shopify && window.Shopify.designMode) return;
    var self = this;
    window.clearTimeout(this.urlTimer);
    this.urlTimer = window.setTimeout(function () {
      var next = self.configUrl(r, false);
      if (next && next !== window.location.href) {
        try { history.replaceState(history.state, '', next); } catch (e) { /* egal */ }
      }
    }, 400);
  };

  Configurator.prototype.share = function () {
    var r = this.current;
    var el = this.el.shareok;
    var url = r ? this.configUrl(r, true) : '';
    if (!url || !el) return;
    var self = this;
    var done = function () { self.showMsg(el, 'Link kopiert. Fügen Sie ihn in eine E-Mail oder einen Chat ein.'); };
    var manual = function () {
      el.innerHTML = '<label class="ek-share__manual"><span>Link zum Kopieren</span><input class="ek-input" type="text" readonly value="' + esc(url) + '"></label>';
      el.hidden = false;
      var inp = el.querySelector('input');
      if (inp) { inp.focus(); inp.select(); }
    };
    try {
      if (navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext !== false) navigator.clipboard.writeText(url).then(done, manual);
      else manual();
    } catch (e) { manual(); }
  };

  /* ---------- Warenkorb ---------- */
  Configurator.prototype.props = function (r, files) {
    var p = {};
    var size = r.round ? 'Ø ' + mm(r.w) + ' mm' : mm(r.w) + ' × ' + mm(r.h) + ' mm';
    p['Form'] = SHAPE_LABEL[r.shape] || r.shape;
    if (r.mode === 'bogen') {
      p['Etikettenmaß'] = size;
      if (r.gx || r.gy) p['Abstände'] = mm(r.gx) + ' mm waagerecht, ' + mm(r.gy) + ' mm senkrecht';
      p['Etiketten je Bogen'] = String(r.per) + ' (' + r.layout.cols + ' × ' + r.layout.rows + (r.layout.rotated ? ', quer' : '') + ')';
      p['Etiketten gesamt'] = int(r.units);
      if (r.motifs > 1) p['Motive'] = String(r.motifs);
    } else {
      p['Maß'] = size;
      if (r.mode === 'rolle') {
        p['Wickelrichtung'] = windText(r.wind);
        p['Abstand auf der Rolle'] = ROLL_GAP + ' mm';
      }
    }
    if (!files.length) p['Druckdaten'] = 'folgen per E-Mail';
    var lay = this.field('layout');
    if (lay && lay.checked) p['Layout-Service'] = 'ja';
    var note = String(this.val('note') || '').trim();
    if (note) p['Hinweis'] = note.slice(0, 500);
    p['_ek'] = JSON.stringify({
      v: 1, m: r.mode, s: r.shape, w: r.w, h: r.h, a: r.area ? Math.round(r.area * 10) / 10 : undefined, c: r.cls,
      b: r.sheetLabel, bm: r.mode === 'bogen' ? r.dims.join('x') : undefined, gx: r.gx, gy: r.gy, n: r.per, q: r.qty, mo: r.motifs, mat: r.mat ? r.mat.handle : '',
      wd: r.mode === 'rolle' ? r.wind : undefined, cut: r.cut && r.mat && r.mat.cuts.length ? r.cut : undefined,
      pos: Date.now().toString(36) + Math.random().toString(36).slice(2, 6)
    });
    return p;
  };

  Configurator.prototype.refText = function (r) {
    var size = r.round ? 'Ø ' + mm(r.w) + ' mm' : mm(r.w) + ' × ' + mm(r.h) + ' mm';
    return (r.mode === 'bogen' ? 'Etiketten auf Bogen' : this.item()) + ', ' + (r.mat ? r.mat.label : '') + ', ' + size + ', ' +
      (r.mode === 'bogen' ? r.sheetLabel + ', ' + int(r.qty) + ' Bogen' : int(r.qty) + ' Stück');
  };

  Configurator.prototype.setBusy = function (on) {
    var buttons = this.form.querySelectorAll('button[type="submit"]');
    Array.prototype.forEach.call(buttons, function (b) {
      if (on) {
        if (!b.getAttribute('data-label')) b.setAttribute('data-label', b.textContent);
        b.textContent = 'Wird übertragen …';
        b.disabled = true;
      } else {
        b.textContent = b.getAttribute('data-label') || b.textContent;
        b.disabled = false;
      }
    });
    this.form.setAttribute('aria-busy', on ? 'true' : 'false');
  };

  function readJson(res) {
    return res.text().then(function (txt) {
      var data = null;
      try { data = JSON.parse(txt); } catch (e) { data = null; }
      if (!res.ok || (data && data.status && data.status >= 400)) {
        var msg = (data && (data.description || data.message)) ||
          (res.status === 413 ? 'Die Datei ist zu groß.' : 'Der Warenkorb hat die Anfrage abgelehnt (Fehler ' + res.status + ').');
        var e = new Error(msg);
        e.ek = true;
        throw e;
      }
      return data;
    });
  }

  Configurator.prototype.submit = function (e) {
    e.preventDefault();
    var r = this.current;
    var el = this.el;
    if (!r || !r.ok) {
      this.showMsg(el.error, (r && r.reason) || 'Bitte prüfen Sie Ihre Angaben.');
      return;
    }
    var upload = this.val('files') !== 'later';
    var files = upload ? this.selectedFiles() : [];
    if (upload && !files.length) {
      this.showMsg(el.error, 'Bitte laden Sie Ihre Druckdatei hoch oder wählen Sie „Später per E-Mail senden“.');
      var input = this.field('file');
      if (input) input.focus();
      return;
    }
    var fileErr = this.checkFiles(files);
    if (fileErr) { this.showMsg(el.error, fileErr); return; }

    var fd = new FormData();
    fd.append('id', String(r.variant.id));
    fd.append('quantity', '1');
    var props = this.props(r, files);
    Object.keys(props).forEach(function (k) { fd.append('properties[' + k + ']', props[k]); });
    files.forEach(function (f, i) {
      fd.append('properties[' + (files.length > 1 ? 'Druckdaten ' + (i + 1) : 'Druckdaten') + ']', f, f.name);
    });
    var ref = this.refText(r);
    var addons = r.addons.map(function (a) {
      var props = { 'Zu': ref };
      if (a.key === 'motif') props['Anzahl'] = a.label;
      return { id: a.id, quantity: a.qty, properties: props };
    });
    var url = this.cfg.cartAddUrl;
    var cartUrl = this.cfg.cartUrl;
    var self = this;
    this.showMsg(el.error, '');
    this.setBusy(true);
    var post = function (items) {
      return fetch(url, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      }).then(readJson);
    };
    fetch(url, { method: 'POST', body: fd, credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(readJson)
      .then(function (line) {
        if (!addons.length) return null;
        var key = line && line.key;
        if (!key) return post(addons);
        /* Datencheck, weitere Motive und Layout-Service hängen am Auftrag: entfernt der Kunde ihn, entfernt Shopify sie mit */
        var nested = addons.map(function (a) { return { id: a.id, quantity: a.quantity, properties: a.properties, parent_line_key: key }; });
        return post(nested).catch(function () { return post(addons); });
      })
      .then(function () { window.location.href = cartUrl; })
      .catch(function (err) {
        self.setBusy(false);
        self.showMsg(el.error, (err && err.ek ? err.message + ' ' : 'Der Warenkorb war gerade nicht erreichbar. ') + 'Bitte versuchen Sie es erneut oder schreiben Sie uns.');
      });
  };

  function init(scope) {
    var nodes = (scope || document).querySelectorAll('[data-ek]');
    Array.prototype.forEach.call(nodes, function (node) {
      if (node.classList.contains('is-ready') || !node.querySelector('[data-ek-form]')) return;
      try {
        node.ekConfigurator = new Configurator(node);
      } catch (err) {
        node.classList.add('is-broken');
        if (window.console) console.error('[etiketten-kaufen] Konfigurator', err);
      }
    });
  }

  window.EkKonfigurator = { init: init, deliveryDate: deliveryDate, fitSheet: fitSheet, firstInt: firstInt, sheetInfo: sheetInfo,
    rollSvg: rollSvg, windText: windText, cutKey: cutKey };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();